// Fallback data from PHP API — used when Go API returns null/404
// Remove each entry once the corresponding Go endpoint is implemented

export const FALLBACK_THEME = {
  id: 5,
  name: 'Light Theme',
  accentColor: '#512da8',
  primaryBackgroundColor: '#ffffff',
  secondaryBackgroundColor: '#f4f8f9',
  menuBackgroundColor: '#110A21',
  primaryBorderColor: '#ced4db',
  primaryFontColor: 'black',
  secondaryFontColor: '#7a7a7a',
  logoSrc: '/assets/images/logo-light.svg',
}

export const FALLBACK_ROLES = [
  {
    id: 9,
    name: 'reseller_admin',
    team: 'reseller',
    displayName: 'Reseller Admin',
  },
  {
    id: 11,
    name: 'reseller_support',
    team: 'reseller',
    displayName: 'Reseller Support',
  },
  {
    id: 13,
    name: 'reseller_installer',
    team: 'reseller',
    displayName: 'Reseller Installer',
  },
  {
    id: 16,
    name: 'installer',
    team: 'client',
    displayName: 'Client Installer',
  },
  {
    id: 10,
    name: 'reseller_sales_manager',
    team: 'reseller',
    displayName: 'Reseller Manager',
  },
  {
    id: 14,
    name: 'account_manager',
    team: 'admin',
    displayName: 'Account Manager',
  },
  {
    id: 15,
    name: 'reseller_account_manager',
    team: 'reseller',
    displayName: 'Reseller Account Manager',
  },
  {
    id: 3,
    name: 'sales_rep',
    team: 'admin',
    displayName: 'Sales Representative',
  },
  {
    id: 1,
    name: 'super_admin',
    team: 'admin',
    displayName: 'SuperAdmin',
  },
  {
    id: 2,
    name: 'admin',
    team: 'admin',
    displayName: 'Admin',
  },
  {
    id: 4,
    name: 'installer',
    team: 'admin',
    displayName: 'Installer',
  },
  {
    id: 5,
    name: 'support',
    team: 'admin',
    displayName: 'Support',
  },
  {
    id: 6,
    name: 'admin',
    team: 'client',
    displayName: 'Admin',
  },
  {
    id: 7,
    name: 'manager',
    team: 'client',
    displayName: 'Manager',
  },
  {
    id: 8,
    name: 'driver',
    team: 'client',
    displayName: 'Driver',
  },
]

export const FALLBACK_EVENT_TYPES = [
  {
    id: 99,
    name: 'VEHICLE_CREATED',
    alias: 'Vehicle added',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 100,
    name: 'VEHICLE_DELETED',
    alias: 'Vehicle deleted',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 101,
    name: 'VEHICLE_UNAVAILABLE',
    alias: 'Vehicle unavailable',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 102,
    name: 'VEHICLE_OFFLINE',
    alias: 'Vehicle offline',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        duration: 'Duration offline',
        shortDetails: 'Details',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: null,
  },
  {
    id: 103,
    name: 'VEHICLE_ONLINE',
    alias: 'Vehicle online',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: null,
  },
  {
    id: 104,
    name: 'VEHICLE_CHANGED_REGNO',
    alias: 'Vehicle rego number changed',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        oldValue: 'Old value',
        eventSource: 'Reg no',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 105,
    name: 'VEHICLE_CHANGED_MODEL',
    alias: 'Vehicle make/model change',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        oldValue: 'Old value',
        eventSource: 'Reg no',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 106,
    name: 'VEHICLE_REASSIGNED',
    alias: 'New driver assigned to vehicle',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        oldValue: 'Old value',
        newValue: 'New value',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: null,
  },
  {
    id: 107,
    name: 'SERVICE_REMINDER_SOON',
    alias: 'Service due soon',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Title',
        vehicleRegNo: 'Reg no',
        expiredDate: 'Expiration date',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: null,
  },
  {
    id: 108,
    name: 'SERVICE_REMINDER_EXPIRED',
    alias: 'Service overdue',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Title',
        vehicleRegNo: 'Reg no',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: null,
  },
  {
    id: 109,
    name: 'SERVICE_REMINDER_DONE',
    alias: 'Service completed',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Title',
        vehicleRegNo: 'Reg no',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 110,
    name: 'SERVICE_REMINDER_DELETED',
    alias: 'Service reminder deleted',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Title',
        vehicleRegNo: 'Reg no',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 111,
    name: 'DOCUMENT_EXPIRE_SOON',
    alias: 'Document expiring soon',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventSource: 'Attach to',
        title: 'Title',
        expiredDate: 'Expiration date',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventSource: 'vehicleId',
          eventId: 'eventId',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: null,
  },
  {
    id: 112,
    name: 'DOCUMENT_EXPIRED',
    alias: 'Document expired',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventSource: 'Reg no',
        title: 'Title',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventSource: 'vehicleId',
          eventId: 'eventId',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: null,
  },
  {
    id: 113,
    name: 'DOCUMENT_DELETED',
    alias: 'Document deleted',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventSource: 'Title',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 114,
    name: 'USER_CREATED',
    alias: 'User created',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'user groups',
        subType: 'user_groups',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'New user',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 115,
    name: 'USER_CREATED\n',
    alias: 'User created (system)',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'user groups',
        subType: 'user_groups',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: null,
    triggeredBy: 'user',
  },
  {
    id: 116,
    name: 'USER_BLOCKED',
    alias: 'User blocked',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'user groups',
        subType: 'user_groups',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Blocked user',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 117,
    name: 'USER_DELETED',
    alias: 'User deleted',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'user groups',
        subType: 'user_groups',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Deleted user',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 118,
    name: 'USER_PWD_RESET',
    alias: 'User password reset',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'user groups',
        subType: 'user_groups',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'User',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          triggeredDetails: 'userBy',
          eventTeam: 'teamBy',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 119,
    name: 'USER_CHANGED_NAME',
    alias: 'User changed name',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'user groups',
        subType: 'user_groups',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        oldValue: 'Old value',
        eventSource: 'User',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 120,
    name: 'USER_CHANGED_SURNAME',
    alias: 'User changed surname',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'user groups',
        subType: 'user_groups',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: null,
    triggeredBy: 'user',
  },
  {
    id: 121,
    name: 'CLIENT_CREATED',
    alias: 'Client created',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 122,
    name: 'CLIENT_DEMO_EXPIRED',
    alias: 'Client demo expired',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        notificationsList: 'Notifications',
      },
      isListenerTeam: false,
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 123,
    name: 'CLIENT_BLOCKED',
    alias: 'Client blocked',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        notificationsList: 'Notifications',
      },
      isListenerTeam: false,
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 124,
    name: 'DEVICE_UNKNOWN_DETECTED',
    alias: 'Device unknown detected',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'device',
        subType: 'device',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventSource: 'Imei',
        notificationsList: 'Notifications',
      },
      isListenerTeam: false,
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: null,
  },
  {
    id: 125,
    name: 'DEVICE_IN_STOCK',
    alias: 'Device in stock',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'device',
        subType: 'device',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Imei',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventSource: 'entityId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 126,
    name: 'DEVICE_OFFLINE',
    alias: 'Device offline',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'device',
        subType: 'device',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Imei',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventSource: 'entityId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 127,
    name: 'DEVICE_UNAVAILABLE',
    alias: 'Device unavailable',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'device',
        subType: 'device',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Imei',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventSource: 'entityId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 128,
    name: 'DEVICE_DELETED',
    alias: 'Device deleted',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'device',
        subType: 'device',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Imei',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventSource: 'entityId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 129,
    name: 'LOGIN_AS_CLIENT',
    alias: 'Login as client',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'user groups',
        subType: 'user_groups',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Logged as',
        notificationsList: 'Notifications',
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 130,
    name: 'LOGIN_AS_USER',
    alias: 'Login as user',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Logged as',
        notificationsList: 'Notifications',
      },
      isListenerTeam: false,
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 131,
    name: 'VEHICLE_GEOFENCE_ENTER',
    alias: 'Vehicle entered area',
    eventSource: 'vehicle',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
    ],
    additionalScopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'area',
        subType: 'area',
      },
      {
        name: 'area group',
        subType: 'area_group',
      },
    ],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        triggeredDetails: 'Driver',
        eventSource: 'Reg no',
        areas: 'Area',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'driverId',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'geo',
  },
  {
    id: 132,
    name: 'VEHICLE_GEOFENCE_ENTER',
    alias: 'Vehicle entered area',
    eventSource: 'vehicle',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
    ],
    additionalScopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'area',
        subType: 'area',
      },
      {
        name: 'area group',
        subType: 'area_group',
      },
    ],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        triggeredDetails: 'Driver',
        eventSource: 'Reg no',
        areas: 'Area',
        shortDetails: 'Details',
        notificationsList: 'Notifications',
      },
    },
    triggeredBy: 'geo',
  },
  {
    id: 133,
    name: 'VEHICLE_GEOFENCE_LEAVE',
    alias: 'Vehicle left area',
    eventSource: 'vehicle',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
    ],
    additionalScopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'area',
        subType: 'area',
      },
      {
        name: 'area group',
        subType: 'area_group',
      },
    ],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        triggeredDetails: 'Driver',
        eventSource: 'Reg no',
        areas: 'Area',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'driverId',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'geo',
  },
  {
    id: 134,
    name: 'VEHICLE_GEOFENCE_LEAVE',
    alias: 'Vehicle left area',
    eventSource: 'vehicle',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
    ],
    additionalScopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'area',
        subType: 'area',
      },
      {
        name: 'area group',
        subType: 'area_group',
      },
    ],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        triggeredDetails: 'Driver',
        eventSource: 'Reg no',
        areas: 'Area',
        shortDetails: 'Details',
        notificationsList: 'Notifications',
      },
    },
    triggeredBy: 'geo',
  },
  {
    id: 135,
    name: 'VEHICLE_OVERSPEEDING_INSIDE_GEOFENCE',
    alias: 'Vehicle overspeeding inside area',
    eventSource: 'vehicle',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
    ],
    additionalScopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'area',
        subType: 'area',
      },
      {
        name: 'area group',
        subType: 'area_group',
      },
    ],
    importance: 'normal',
    additionalSettings: {
      isOverSpeed: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        triggeredDetails: 'Driver',
        eventSource: 'Reg no',
        areas: 'Area',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        maxSpeed: 'Speed',
        limit: 'Limit',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'vehicleId',
          eventSource: 'driverId',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'geo',
  },
  {
    id: 136,
    name: 'VEHICLE_OVERSPEEDING',
    alias: 'Maximum Speed',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'area',
        subType: 'area',
      },
      {
        name: 'area group',
        subType: 'area_group',
      },
    ],
    importance: 'normal',
    additionalSettings: {
      isOverSpeed: true,
      isTimeDuration: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        triggeredDetails: 'Driver',
        eventSource: 'Reg no',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        areas: 'Area',
        maxSpeed: 'Speed',
        duration: 'Duration',
        distance: 'Distance',
        limit: 'Limit',
        address: 'Address',
        notificationsList: 'Notifications',
      },
      isDistance: true,
      isExpressionOperator: true,
      isAreaTriggerType: true,
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
          eventSource: 'vehicleId',
        },
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 137,
    name: 'VEHICLE_LONG_STANDING',
    alias: 'Standing longer than defined',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'area',
        subType: 'area',
      },
      {
        name: 'area group',
        subType: 'area_group',
      },
    ],
    importance: 'normal',
    additionalSettings: {
      isTimeDuration: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        triggeredDetails: 'Driver',
        eventSource: 'Reg no',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        areas: 'Area',
        duration: 'Duration',
        limit: 'Limit',
        address: 'Address',
        notificationsList: 'Notifications',
      },
      isAreaTriggerType: true,
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
          eventSource: 'vehicleId',
        },
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 138,
    name: 'VEHICLE_LONG_DRIVING',
    alias: 'Driving longer than defined',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'area',
        subType: 'area',
      },
      {
        name: 'area group',
        subType: 'area_group',
      },
    ],
    importance: 'normal',
    additionalSettings: {
      isTimeDuration: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        triggeredDetails: 'Driver',
        eventSource: 'Reg no',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        areas: 'Area',
        duration: 'Duration',
        distance: 'Distance',
        limit: 'Limit',
        address: 'Address',
        notificationsList: 'Notifications',
      },
      isDistance: true,
      isExpressionOperator: true,
      isAreaTriggerType: true,
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
          eventSource: 'vehicleId',
        },
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 139,
    name: 'VEHICLE_MOVING',
    alias: 'Vehicle is moving',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'area',
        subType: 'area',
      },
      {
        name: 'area group',
        subType: 'area_group',
      },
    ],
    importance: 'normal',
    additionalSettings: {
      isTimeDuration: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        areas: 'Area',
        duration: 'Duration',
        distance: 'Distance',
        limit: 'Limit',
        address: 'Address',
        notificationsList: 'Notifications',
      },
      isDistance: true,
      isExpressionOperator: true,
      isAreaTriggerType: true,
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventSource: 'vehicleId',
        },
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 140,
    name: 'VEHICLE_EXCESSING_IDLING',
    alias: 'Excess Idling',
    eventSource: 'vehicle',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'area',
        subType: 'area',
      },
      {
        name: 'area group',
        subType: 'area_group',
      },
    ],
    importance: 'normal',
    additionalSettings: {
      isTimeDuration: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Driver',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        areas: 'Area',
        limit: 'Limit',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'driverId',
          eventTeam: 'entityTeamId',
        },
      },
      isAreaTriggerType: true,
    },
    triggeredBy: 'driver',
  },
  {
    id: 141,
    name: 'VEHICLE_TOWING_EVENT',
    alias: 'Vehicle being towed',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Driver',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        address: 'Address',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
          eventSource: 'vehicleId',
        },
      },
      isTimeDuration: true,
    },
    triggeredBy: 'driver',
  },
  {
    id: 142,
    name: 'VEHICLE_DRIVING_WITHOUT_DRIVER',
    alias: 'Driving without assigned driver',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isTimeDuration: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        notificationsList: 'Notifications',
      },
      isDistance: true,
      isExpressionOperator: true,
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventSource: 'vehicleId',
        },
      },
    },
    triggeredBy: null,
  },
  {
    id: 143,
    name: 'DRIVER_ROUTE_UNDEFINED',
    alias: 'Driver route undefined',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        notificationsList: 'Notifications',
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 144,
    name: 'SERVICE_RECORD_ADDED',
    alias: 'Service reminder added',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Title',
        vehicleRegNo: 'Reg no',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 145,
    name: 'SERVICE_REPAIR_ADDED',
    alias: 'Repair Added',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Title',
        vehicleRegNo: 'Reg no',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 146,
    name: 'DOCUMENT_RECORD_ADDED',
    alias: 'Document added',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Attach to',
        title: 'Title',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventSource: 'vehicleId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 147,
    name: 'TRACKER_VOLTAGE',
    alias: 'Supply Voltage',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
    ],
    additionalScopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'area',
        subType: 'area',
      },
      {
        name: 'area group',
        subType: 'area_group',
      },
    ],
    importance: 'normal',
    additionalSettings: {
      isDeviceVoltage: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Driver',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        deviceVoltage: 'Voltage',
        limit: 'Limit',
        notificationsList: 'Notifications',
      },
      isTimeDuration: true,
      isDistance: true,
      isExpressionOperator: true,
      isAreaTriggerType: true,
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
          eventSource: 'vehicleId',
        },
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 148,
    name: 'PANIC_BUTTON',
    alias: 'SOS button',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Driver',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        address: 'Address',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
          eventSource: 'vehicleId',
        },
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 149,
    name: 'ADMIN_USER_CREATED',
    alias: 'User created',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'New user',
        notificationsList: 'Notifications',
      },
      isListenerTeam: false,
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 150,
    name: 'ADMIN_USER_BLOCKED',
    alias: 'User blocked',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Blocked user',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 151,
    name: 'ADMIN_USER_DELETED',
    alias: 'User deleted',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Deleted user',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 152,
    name: 'ADMIN_USER_PWD_RESET',
    alias: 'User password reset',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'User',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 153,
    name: 'ADMIN_USER_CHANGED_NAME',
    alias: 'User changed name',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        oldValue: 'Old value',
        eventSource: 'User',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 154,
    name: 'USER_CREATED_SYSTEM',
    alias: 'User created (system)',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'user groups',
        subType: 'user_groups',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: null,
    triggeredBy: 'user',
  },
  {
    id: 155,
    name: 'ODOMETER_CORRECTED',
    alias: 'Vehicle odometer corrected',
    eventSource: 'vehicle',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Title',
        oldValue: 'Old value',
        newValue: 'New value',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 158,
    name: 'DIGITAL_FORM_WITH_FAIL',
    alias: 'Failed inspection',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Title',
        vehicleRegNo: 'Reg no',
        user: 'By user',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 159,
    name: 'DIGITAL_FORM_IS_NOT_COMPLETED',
    alias: 'Digital form is not completed',
    eventSource: 'vehicle',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isDriverToRecipient: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        form: 'Title',
        eventSource: 'Reg no',
        triggeredDetails: 'Driver',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 160,
    name: 'DIGITAL_FORM_IS_NOT_COMPLETED',
    alias: 'Digital form is not completed',
    eventSource: 'vehicle',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isDriverToRecipient: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        triggeredDetails: 'Driver',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 161,
    name: 'SENSOR_TEMPERATURE',
    alias: 'Sensor temperature',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'sensor',
        subType: 'sensor',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isSensorTemperature: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By sensor',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        sensorTemperature: 'Temperature',
        limit: 'Limit',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'entityId',
        },
      },
    },
    triggeredBy: 'sensor',
  },
  {
    id: 162,
    name: 'SENSOR_HUMIDITY',
    alias: 'Sensor humidity',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'sensor',
        subType: 'sensor',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isSensorHumidity: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By sensor',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        sensorHumidity: 'Humidity',
        limit: 'Limit',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'entityId',
        },
      },
    },
    triggeredBy: 'sensor',
  },
  {
    id: 163,
    name: 'SENSOR_LIGHT',
    alias: 'Sensor light',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'sensor',
        subType: 'sensor',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isSensorLight: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By sensor',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        sensorLight: 'Light',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'sensor',
  },
  {
    id: 164,
    name: 'SENSOR_BATTERY_LEVEL',
    alias: 'Sensor battery level',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'sensor',
        subType: 'sensor',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isSensorBatteryLevel: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By sensor',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        sensorBatteryLevel: 'Battery Level',
        limit: 'Limit',
        notificationsList: 'Notifications',
      },
      isBatteryLevel: true,
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'sensor',
  },
  {
    id: 165,
    name: 'SENSOR_STATUS',
    alias: 'Sensor status',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'sensor',
        subType: 'sensor',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isSensorStatus: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By sensor',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        sensorStatus: 'Status',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'sensor',
  },
  {
    id: 166,
    name: 'DRIVER_DOCUMENT_EXPIRE_SOON',
    alias: 'Document expiring soon',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventSource: 'Attach to',
        title: 'Title',
        expiredDate: 'Expiration date',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventSource: 'driverId',
          eventId: 'eventId',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: null,
  },
  {
    id: 167,
    name: 'DRIVER_DOCUMENT_EXPIRED',
    alias: 'Document expired',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventSource: 'By user',
        title: 'Title',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventSource: 'driverId',
          eventId: 'eventId',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: null,
  },
  {
    id: 168,
    name: 'DRIVER_DOCUMENT_DELETED',
    alias: 'Document deleted',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventSource: 'Title',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 169,
    name: 'DRIVER_DOCUMENT_RECORD_ADDED',
    alias: 'Document added',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'driver',
        subType: 'driver',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Attach to',
        title: 'Title',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventSource: 'driverId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 170,
    name: 'SENSOR_IO_STATUS',
    alias: 'Digital I/O',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'sensor',
        subType: 'sensor',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isSensorIOStatus: true,
      isSensorIOType: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Driver',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        sensorStatus: 'Status',
        sensorIoType: 'Digital I/O Type',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
        },
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 171,
    name: 'ASSET_DOCUMENT_EXPIRE_SOON',
    alias: 'Asset document expire soon',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Driver',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        notificationsList: 'Notifications',
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 172,
    name: 'ASSET_DOCUMENT_EXPIRED',
    alias: 'Asset document expired',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Driver',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        notificationsList: 'Notifications',
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 173,
    name: 'ASSET_DOCUMENT_DELETED',
    alias: 'Asset document deleted',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Driver',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        notificationsList: 'Notifications',
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 174,
    name: 'ASSET_DOCUMENT_RECORD_ADDED',
    alias: 'Asset document record added',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Driver',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        notificationsList: 'Notifications',
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 175,
    name: 'ASSET_CREATED',
    alias: 'Asset created',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Created by',
        eventTeam: 'Team',
        eventSource: 'Asset',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 176,
    name: 'ASSET_DELETED',
    alias: 'Asset deleted',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'asset',
        subType: 'asset',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Deleted by',
        eventTeam: 'Team',
        eventSource: 'Asset',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 177,
    name: 'ASSET_MISSED',
    alias: 'Asset missed',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'asset',
        subType: 'asset',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isTimeDuration: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        eventSource: 'Asset',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
        },
      },
    },
    triggeredBy: 'sensor',
  },
  {
    id: 178,
    name: 'TRACKER_BATTERY_PERCENTAGE',
    alias: 'Battery Voltage Percentage',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isDeviceBatteryPercentage: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Driver',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        deviceBatteryPercentage: 'Battery Percentage',
        limit: 'Limit',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
          eventSource: 'vehicleId',
        },
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 179,
    name: 'STRIPE_INTEGRATION_ERROR',
    alias: 'Stripe integration error',
    eventSource: 'device',
    scopes: [
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        shortDetails: 'Details',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 180,
    name: 'STRIPE_PAYMENT_METHOD_MISSING',
    alias: 'Stripe payment method missing',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 181,
    name: 'STRIPE_PAYMENT_FAILED',
    alias: 'Stripe payment failed',
    eventSource: 'device',
    scopes: [
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        shortDetails: 'Details',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 182,
    name: 'STRIPE_PAYMENT_SUCCESSFUL',
    alias: 'Stripe payment successful',
    eventSource: 'device',
    scopes: [
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 183,
    name: 'XERO_INTEGRATION_ERROR',
    alias: 'Xero integration error',
    eventSource: 'device',
    scopes: [
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        shortDetails: 'Details',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 184,
    name: 'XERO_INVOICE_CREATION_ERROR',
    alias: 'Xero invoice creation error',
    eventSource: 'device',
    scopes: [
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        shortDetails: 'Details',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 185,
    name: 'XERO_INVOICE_CREATED',
    alias: 'Xero invoice created',
    eventSource: 'device',
    scopes: [
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Xero Invoice',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 186,
    name: 'XERO_PAYMENT_CREATION_ERROR',
    alias: 'Xero payment creation error',
    eventSource: 'device',
    scopes: [
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Xero Invoice',
        shortDetails: 'Details',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 187,
    name: 'XERO_PAYMENT_CREATED',
    alias: 'Xero payment created',
    eventSource: 'device',
    scopes: [
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Xero Invoice',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 188,
    name: 'INVOICE_CREATED',
    alias: 'Invoice created',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 189,
    name: 'PAYMENT_FAILED',
    alias: 'Payment failed',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        shortDetails: 'Details',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 190,
    name: 'PAYMENT_SUCCESSFUL',
    alias: 'Payment successful',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 191,
    name: 'INVOICE_OVERDUE',
    alias: 'Invoice overdue',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 192,
    name: 'INVOICE_OVERDUE_PARTIALLY_BLOCKED',
    alias: 'Invoice overdue - Account partially blocked',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 193,
    name: 'INVOICE_OVERDUE_BLOCKED',
    alias: 'Invoice overdue - Account blocked',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 194,
    name: 'INVOICE_CREATED_ADMIN',
    alias: 'Invoice created admin',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 195,
    name: 'INVOICE_OVERDUE_ADMIN',
    alias: 'Invoice overdue',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 196,
    name: 'INVOICE_OVERDUE_PARTIALLY_BLOCKED_ADMIN',
    alias: 'Invoice overdue - Account partially blocked',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 197,
    name: 'INVOICE_OVERDUE_BLOCKED_ADMIN',
    alias: 'Invoice overdue - Account blocked',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        eventTeam: 'Team',
        extInvoiceId: 'Invoice',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 198,
    name: 'DEVICE_CONTRACT_EXPIRED',
    alias: 'Device contract expired',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Imei',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventSource: 'entityId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 199,
    name: 'TRACKER_JAMMER_STARTED_ALARM',
    alias: 'Jammer is started',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Driver',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
          eventSource: 'vehicleId',
        },
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 200,
    name: 'TRACKER_ACCIDENT_HAPPENED_ALARM',
    alias: 'Accident happened',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'Driver',
        eventTeam: 'Team',
        eventSource: 'Reg no',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
          eventSource: 'vehicleId',
        },
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 201,
    name: 'DEVICE_REPLACED',
    alias: 'Device replaced',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'device',
        subType: 'device',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Imei',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventSource: 'entityId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 202,
    name: 'EXCEEDING_SPEED_LIMIT',
    alias: 'Exceeding speed limit',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'vehicle',
        subType: 'vehicle',
      },
      {
        name: 'depot',
        subType: 'depot',
      },
      {
        name: 'group',
        subType: 'group',
      },
      {
        name: 'team',
        subType: 'team',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isTimeDuration: true,
      isThresholdSpeedLimit: true,
      isDistance: true,
      isExpressionOperator: true,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        eventTeam: 'Team',
        triggeredDetails: 'Driver',
        eventSource: 'Reg no',
        defaultLabel: 'Vehicle Title',
        shortDetails: 'Details',
        deviceImei: 'Imei',
        speedLimit: 'Limit',
        maxSpeed: 'Speed',
        speedOverLimitPercent: '% Over Limit',
        distance: 'Distance',
        duration: 'Duration',
        address: 'Address',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          eventId: 'eventId',
          id: 'id',
          formattedDate: 'eventDate',
          eventTeam: 'entityTeamId',
          triggeredDetails: 'driverId',
          eventSource: 'vehicleId',
        },
      },
    },
    triggeredBy: 'driver',
  },
  {
    id: 203,
    name: 'INTEGRATION_ENABLED',
    alias: 'Integration enabled',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'team type',
        subType: 'team_type',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      isListenerTeam: false,
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
  {
    id: 204,
    name: 'ACCESS_LEVEL_CHANGED',
    alias: 'Access level changed',
    eventSource: 'device',
    scopes: [
      {
        name: 'any',
        subType: 'any',
      },
      {
        name: 'user',
        subType: 'user',
      },
      {
        name: 'role',
        subType: 'role',
      },
      {
        name: 'team',
        subType: 'team',
      },
      {
        name: 'user groups',
        subType: 'user_groups',
      },
    ],
    additionalScopes: [],
    importance: 'normal',
    additionalSettings: {
      headersColumns: {
        id: 'ID',
        formattedDate: 'Date',
        importance: 'Importance',
        triggeredDetails: 'By user',
        eventTeam: 'Team',
        eventSource: 'Blocked user',
        notificationsList: 'Notifications',
      },
      eventLog: {
        mappingFilters: {
          id: 'id',
          formattedDate: 'eventDate',
          triggeredDetails: 'userBy',
          eventTeam: 'entityTeamId',
          eventId: 'eventId',
        },
      },
    },
    triggeredBy: 'user',
  },
]

export const FALLBACK_SETTINGS = [
  {
    id: '22143',
    role: null,
    user: null,
    name: 'asset',
    value: 0,
  },
  {
    id: '197096',
    role: null,
    user: null,
    name: 'billableAddons',
    value: [],
  },
  {
    id: '57542',
    role: null,
    user: null,
    name: 'billing',
    value: false,
  },
  {
    id: '232611',
    role: null,
    user: null,
    name: 'biometricLogin',
    value: false,
  },
  {
    id: '213345',
    role: null,
    user: null,
    name: 'cameras',
    value: false,
  },
  {
    id: '32195',
    role: null,
    user: null,
    name: 'dateFormat',
    value: 'DD/MM/YYYY',
  },
  {
    id: '54',
    role: null,
    user: null,
    name: 'deviceVoltage',
    value: {
      value: 3700,
    },
  },
  {
    id: '7186',
    role: null,
    user: null,
    name: 'digitalForm',
    value: false,
  },
  {
    id: '27845',
    role: null,
    user: null,
    name: 'disallowDriverLoginWebapp',
    value: false,
  },
  {
    id: '132400',
    role: null,
    user: null,
    name: 'driverAutoLogout',
    value: {
      value: 0,
      enable: false,
    },
  },
  {
    id: '206144',
    role: null,
    user: null,
    name: 'driverAutoLogoutByApp',
    value: {
      value: 0,
      enable: false,
    },
  },
  {
    id: '209351',
    role: null,
    user: null,
    name: 'driverAutoLogoutByVehicle',
    value: {
      value: 0,
      enable: false,
    },
  },
  {
    id: '129966',
    role: null,
    user: null,
    name: 'driverAutoLogoutOption',
    value: false,
  },
  {
    id: '282961',
    role: null,
    user: null,
    name: 'driverVehiclesAccessType',
    value: 'allDriven',
  },
  {
    id: '9010',
    role: null,
    user: null,
    name: 'drivingBehaviorCalculationType',
    value: 'route',
  },
  {
    id: '51',
    role: null,
    user: null,
    name: 'ecoSpeed',
    value: {
      value: 85,
    },
  },
  {
    id: '45',
    role: null,
    user: null,
    name: 'email',
    value: true,
  },
  {
    id: '42602',
    role: null,
    user: null,
    name: 'endTrip',
    value: {
      value: 600,
      enable: false,
    },
  },
  {
    id: '52',
    role: null,
    user: null,
    name: 'excessiveIdling',
    value: {
      value: 120,
    },
  },
  {
    id: '41828',
    role: null,
    user: null,
    name: 'gpsStatusDuration',
    value: {
      value: 14400,
      enable: true,
    },
  },
  {
    id: '13688',
    role: null,
    user: null,
    name: 'hideFormsOnTheDashboardsInMobileApp',
    value: false,
  },
  {
    id: '44924',
    role: null,
    user: null,
    name: 'idling',
    value: {
      value: 300,
      enable: true,
    },
  },
  {
    id: '44150',
    role: null,
    user: null,
    name: 'ignoreMovement',
    value: {
      value: 50,
      enable: true,
    },
  },
  {
    id: '43376',
    role: null,
    user: null,
    name: 'ignoreStops',
    value: {
      value: 30,
      enable: true,
    },
  },
  {
    id: '46',
    role: null,
    user: null,
    name: 'inApp',
    value: true,
  },
  {
    id: '57',
    role: null,
    user: null,
    name: 'inspectionFormPeriod',
    value: 'inspectionFormPeriodEveryTime',
  },
  {
    id: '5431',
    role: null,
    user: null,
    name: 'integrations',
    value: [1, 2, 3, 4, 5],
  },
  {
    id: '48',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '19842',
      email: 'jimmy.mao@linxio.com',
      name: 'Jimmy',
      surname: 'Mao',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61416086580',
      status: 'active',
      lastLoggedAt: '2026-04-27T23:04:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'language',
    value: 'en',
  },
  {
    id: '49253',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '33067',
      email: 'vaibhavb13323@gmail.com',
      name: 'Vaibhav',
      surname: 'B',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-03-27T18:36:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'language',
    value: 'en',
  },
  {
    id: '89784',
    role: null,
    user: null,
    name: 'language',
    value: 'en',
  },
  {
    id: '120',
    role: null,
    user: null,
    name: 'loginWithId',
    value: false,
  },
  {
    id: '56',
    role: null,
    user: null,
    name: 'longStandingDuration',
    value: {
      value: 600,
    },
  },
  {
    id: '59',
    role: null,
    user: null,
    name: 'mapApiOptions',
    value: [1, 2, 3],
  },
  {
    id: '272507',
    role: null,
    user: null,
    name: 'messenger',
    value: false,
  },
  {
    id: '56340',
    role: null,
    user: null,
    name: 'messengerUploadFileLimit',
    value: {
      value: 10000000,
    },
  },
  {
    id: '12707',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '1786',
      email: 'developer+ak@linxio.com',
      name: 'Alexei',
      surname: 'K',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+375297624557',
      status: 'archive',
      lastLoggedAt: '2025-04-16T16:05:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '335011',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '30742',
      email: 'nitin13323@gmail.com',
      name: 'Nitin',
      surname: 'Kumar',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+917837379125',
      status: 'active',
      lastLoggedAt: '2025-07-29T09:22:21+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '8056',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '17',
      email: 'developer+sp@linxio.com',
      name: 'Serge',
      surname: 'P',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+375293231454',
      status: 'archive',
      lastLoggedAt: '2025-05-26T10:35:17+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '142494',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '20',
      email: 'developer+dk@linxio.com',
      name: 'Dmitry',
      surname: 'K',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+375447130716',
      status: 'archive',
      lastLoggedAt: '2024-06-27T10:17:10+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '373593',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '11461',
      email: 'graham.carter@linxio.com',
      name: 'Graham',
      surname: 'Carter',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61413436249',
      status: 'active',
      lastLoggedAt: '2026-04-30T00:13:04+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '12597',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '1772',
      email: 'developer+at2@linxio.com',
      name: 'Alex',
      surname: 'T',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+375447966952',
      status: 'archive',
      lastLoggedAt: '2021-12-22T12:58:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '49059',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '4786',
      email: 'sales+support@linxio.com',
      name: 'Linxio',
      surname: 'Support',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+123456789',
      status: 'blocked',
      lastLoggedAt: '2023-02-07T22:20:00+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '324216',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '28770',
      email: 'dhen.mark@linxio.com',
      name: 'Dhen Mark',
      surname: 'Torreno',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+37382781',
      status: 'blocked',
      lastLoggedAt: '2025-01-16T05:15:30+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '407817',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '19842',
      email: 'jimmy.mao@linxio.com',
      name: 'Jimmy',
      surname: 'Mao',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61416086580',
      status: 'active',
      lastLoggedAt: '2026-04-27T23:04:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '367813',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '3970',
      email: 'john.baldoria@linxio.com',
      name: 'John',
      surname: 'Baldoria',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61433649110',
      status: 'active',
      lastLoggedAt: '2026-04-29T23:50:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '373589',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '16095',
      email: 'dylan.tran@linxio.com',
      name: 'Dylan',
      surname: 'Tran',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61423799688',
      status: 'active',
      lastLoggedAt: '2026-04-24T00:28:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '53038',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '5202',
      email: 'developer+hs@linxio.com',
      name: 'Hanna',
      surname: 'Sh',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+375336700825',
      status: 'deleted',
      lastLoggedAt: '2024-06-28T05:36:40+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '41181',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '4416',
      email: 'amesh.desilva@linxio.com',
      name: 'Amesh',
      surname: 'De Silva',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61401218936',
      status: 'blocked',
      lastLoggedAt: '2022-02-10T00:41:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '260191',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '24056',
      email: 'genette.casas@linxio.com',
      name: 'Genette',
      surname: 'Casas',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+12345678',
      status: 'blocked',
      lastLoggedAt: '2024-07-31T13:36:57+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '292871',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '26268',
      email: 'marben.bagting@linxio.com',
      name: 'Marben',
      surname: 'Bagting',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-30T00:27:35+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '10356',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '1599',
      email: 'support@linxio.com',
      name: 'Support',
      surname: 'Support',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61419403003',
      status: 'blocked',
      lastLoggedAt: '2025-08-08T04:45:52+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '356499',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '32387',
      email: 'jasper.sampang@linxio.com',
      name: 'Jasper',
      surname: 'Sampang',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+09052373445',
      status: 'active',
      lastLoggedAt: '2026-04-29T23:15:11+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '302050',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '27083',
      email: 'hiroshi.santos@linxio.com',
      name: 'Hiroshi',
      surname: 'Santos',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234564879797',
      status: 'archive',
      lastLoggedAt: '2024-09-02T10:26:17+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '300029',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '26884',
      email: 'ezra.galacan@linxio.com',
      name: 'Ezra',
      surname: 'Galacan',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'deleted',
      lastLoggedAt: '2025-03-11T22:34:24+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '17052',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '2284',
      email: 'ramez.habib@linxio.com',
      name: 'Ramez',
      surname: 'Habib',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61402491285',
      status: 'archive',
      lastLoggedAt: '2024-09-26T00:08:21+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '411780',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '37259',
      email: 'john.waine@linxio.com',
      name: 'John',
      surname: 'Waine',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+09676421733',
      status: 'active',
      lastLoggedAt: '2026-04-30T01:30:39+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '19329',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '1580',
      email: 'dean.grey@linxio.com',
      name: 'Dean',
      surname: 'Grey',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61421777794',
      status: 'blocked',
      lastLoggedAt: '2023-01-22T00:42:43+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '392395',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '35422',
      email: 'bao.tran@linxio.com',
      name: 'Bao',
      surname: 'Tran',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-01-30T03:15:15+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '37222',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '3970',
      email: 'john.baldoria@linxio.com',
      name: 'John',
      surname: 'Baldoria',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61433649110',
      status: 'active',
      lastLoggedAt: '2026-04-29T23:50:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '264667',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '24397',
      email: 'monchou.dacumos@linxio.com',
      name: 'Monchou',
      surname: 'Dacumos',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+11111111',
      status: 'archive',
      lastLoggedAt: '2026-04-24T04:36:26+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '50410',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '4923',
      email: 'dennis+admin@linxio.com',
      name: 'Dennis',
      surname: 'Papadatos',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+123456789',
      status: 'new',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '51177',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '5056',
      email: 'william.mclean+admin@linxio.com',
      name: 'William',
      surname: 'McLean',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61417588235',
      status: 'blocked',
      lastLoggedAt: '2024-02-21T23:15:56+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '367862',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '25339',
      email: 'michelle.nonato@linxio.com',
      name: 'Michelle',
      surname: 'Nonato',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61111111',
      status: 'active',
      lastLoggedAt: '2025-12-19T03:22:18+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '60469',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '5572',
      email: 'developer+kk@linxio.com',
      name: 'Kiryl',
      surname: 'K',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+375257794915',
      status: 'archive',
      lastLoggedAt: '2022-08-09T14:46:04+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '89145',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '5024',
      email: 'dylan.tran@linxio.com1',
      name: 'Dylan',
      surname: 'Tran',
      role: {
        id: 5,
        name: 'support',
        displayName: 'Support',
      },
      phone: '+61423799688',
      status: 'blocked',
      lastLoggedAt: '2023-03-05T22:49:58+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '279237',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '25265',
      email: 'daryl.lozanes@linxio.com',
      name: 'Daryl',
      surname: 'Lozanes',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-26T23:16:15+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '365902',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '33067',
      email: 'vaibhavb13323@gmail.com',
      name: 'Vaibhav',
      surname: 'B',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-03-27T18:36:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '365273',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '33037',
      email: 'pyaesone1732@gmail.com',
      name: 'Pyae',
      surname: 'Sone',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-02-26T04:59:35+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '361176',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '32785',
      email: 'kate.allison@linxio.com',
      name: 'Kate',
      surname: 'Allison',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61413436249',
      status: 'archive',
      lastLoggedAt: '2026-02-19T22:53:43+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '353761',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '32206',
      email: 'thisbe.notarte@linxio.com',
      name: 'thisbe',
      surname: 'notarte',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+639365627315',
      status: 'blocked',
      lastLoggedAt: '2025-04-28T22:45:35+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '145288',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '16095',
      email: 'dylan.tran@linxio.com',
      name: 'Dylan',
      surname: 'Tran',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61423799688',
      status: 'active',
      lastLoggedAt: '2026-04-24T00:28:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '147229',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '16280',
      email: 'neil.carter@linxio.com',
      name: 'Neil',
      surname: 'Carter',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61406708626',
      status: 'blocked',
      lastLoggedAt: '2024-04-25T23:15:47+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '340970',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '31242',
      email: 'darwin.argulane@linxio.com',
      name: 'Darwin',
      surname: 'Argulane',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+639953090292',
      status: 'deleted',
      lastLoggedAt: '2025-04-10T01:21:16+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '310076',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '27601',
      email: 'andrew.mercado@linxio.com',
      name: 'Andrew',
      surname: 'Mercado',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-28T23:40:31+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '339566',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '31161',
      email: 'ben.li@linxio.com',
      name: 'Ben',
      surname: 'Li',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61425290521',
      status: 'archive',
      lastLoggedAt: '2025-09-19T06:05:20+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '317326',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '28230',
      email: 'ellen.marie@linxio.com',
      name: 'Ellen',
      surname: 'Marie',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-29T23:09:17+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '330346',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '29873',
      email: 'myint.oo@linxio.com',
      name: 'Myint',
      surname: 'Oo',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-27T06:24:02+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '308924',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '27516',
      email: 'tahmed@banyansoftware.com',
      name: 'Taha',
      surname: 'Ahmed',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61123456',
      status: 'deleted',
      lastLoggedAt: '2024-11-25T00:57:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '308922',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '27515',
      email: 'pstrong@banyansoftware.com',
      name: 'Pippa',
      surname: 'Strong',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61123456',
      status: 'blocked',
      lastLoggedAt: '2025-03-24T03:57:59+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '50884',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '4989',
      email: 'joshua.dodds@linxio.com',
      name: 'Joshua',
      surname: 'Dodds',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+123456789',
      status: 'deleted',
      lastLoggedAt: '2024-03-12T23:48:59+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '148107',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '16365',
      email: 'howard.wong@linxio.com',
      name: 'Howard',
      surname: 'Wong',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+61422338080',
      status: 'active',
      lastLoggedAt: '2026-04-30T01:02:02+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '339562',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '31159',
      email: 'kevin.khuu@linxio.com',
      name: 'Kevin',
      surname: 'Khuu',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+61421675117',
      status: 'archive',
      lastLoggedAt: '2025-09-09T23:32:51+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '59214',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '5399',
      email: 'joshuadodds@0.com',
      name: 'Joshua',
      surname: 'Dodds',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+123456798',
      status: 'deleted',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '339564',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '31160',
      email: 'morgan.to@linxio.com',
      name: 'Morgan',
      surname: 'To',
      role: {
        id: 4,
        name: 'installer',
        displayName: 'Installer',
      },
      phone: '+61469336047',
      status: 'archive',
      lastLoggedAt: '2026-04-10T01:00:18+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '393695',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '35547',
      email: 'tim.barsoum@linxio.com',
      name: 'Tim',
      surname: 'Barsoum',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+123456789',
      status: 'active',
      lastLoggedAt: '2026-04-30T03:19:13+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '310231',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '27613',
      email: 'vanessa.crisante@linxio.com',
      name: 'Vanessa ',
      surname: 'Crisante',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+61497323054',
      status: 'active',
      lastLoggedAt: '2026-03-23T07:06:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '59216',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '5400',
      email: 'meganfisquet@0.com',
      name: 'Megan',
      surname: 'Fisquet',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+123456789',
      status: 'deleted',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '171794',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '18503',
      email: 'aaqil.sahib@linxio.com',
      name: 'Aaqil',
      surname: 'Sahib',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+61451254928',
      status: 'blocked',
      lastLoggedAt: '2024-02-29T00:51:58+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '410859',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '37162',
      email: 'luongviethai@linxio.com',
      name: 'Hai',
      surname: 'Viet Luong',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-21T01:38:18+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '407692',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '36782',
      email: 'jimmy.mao+sales@linxio.com',
      name: 'Jimmy',
      surname: 'Mao',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+1234567',
      status: 'new',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '24690',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '2950',
      email: 'sales@nxgentechs.com',
      name: 'Maria',
      surname: 'Mascarenhas',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+1234567890',
      status: 'blocked',
      lastLoggedAt: '2022-02-21T14:03:12+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '253185',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '23094',
      email: 'caleb.bacon@linxio.com',
      name: 'Caleb',
      surname: 'Bacon',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+61432154709',
      status: 'active',
      lastLoggedAt: '2026-04-28T04:30:58+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '410861',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '37163',
      email: 'linhnguyen@linxio.com',
      name: 'Linh',
      surname: 'Nguyen',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-30T03:47:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '9938',
    role: {
      id: 4,
      name: 'installer',
      displayName: 'Installer',
    },
    user: {
      id: '1570',
      email: 'hello@taskbranch.com',
      name: 'Task',
      surname: 'branch',
      role: {
        id: 4,
        name: 'installer',
        displayName: 'Installer',
      },
      phone: '+61419403003',
      status: 'archive',
      lastLoggedAt: '2021-02-02T09:10:26+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '389500',
    role: {
      id: 4,
      name: 'installer',
      displayName: 'Installer',
    },
    user: {
      id: '35016',
      email: 'george.qiang@linxio.com',
      name: 'George',
      surname: 'Zhi Quiang',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61466289467',
      status: 'active',
      lastLoggedAt: '2026-04-30T03:40:35+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '200457',
    role: {
      id: 4,
      name: 'installer',
      displayName: 'Installer',
    },
    user: {
      id: '20322',
      email: 'nick+installer@linxio.com',
      name: 'Nick',
      surname: 'Bailey',
      role: {
        id: 4,
        name: 'installer',
        displayName: 'Installer',
      },
      phone: '+61423760909',
      status: 'archive',
      lastLoggedAt: '2023-10-13T06:24:04+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '308734',
    role: {
      id: 4,
      name: 'installer',
      displayName: 'Installer',
    },
    user: {
      id: '27503',
      email: 'jimmy.mao.11.11@gmail.com',
      name: 'Jimmy',
      surname: 'installer',
      role: {
        id: 4,
        name: 'installer',
        displayName: 'Installer',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2024-10-11T00:24:56+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '398141',
    role: {
      id: 4,
      name: 'installer',
      displayName: 'Installer',
    },
    user: {
      id: '35979',
      email: 'dylan.tran+installer@linxio.com',
      name: 'Dylan',
      surname: 'Tran',
      role: {
        id: 4,
        name: 'installer',
        displayName: 'Installer',
      },
      phone: '+123456789',
      status: 'active',
      lastLoggedAt: '2025-11-26T02:53:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '279689',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '25339',
      email: 'michelle.nonato@linxio.com',
      name: 'Michelle',
      surname: 'Nonato',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61111111',
      status: 'active',
      lastLoggedAt: '2025-12-19T03:22:18+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '304011',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '27215',
      email: 'ronnel.rana@linxio.com',
      name: 'Ronnel',
      surname: 'Rana',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'archive',
      lastLoggedAt: '2024-09-22T23:17:51+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '104891',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '11461',
      email: 'graham.carter@linxio.com',
      name: 'Graham',
      surname: 'Carter',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61413436249',
      status: 'active',
      lastLoggedAt: '2026-04-30T00:13:04+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '306834',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '27421',
      email: 'mark.almase@linxio.com',
      name: 'Mark',
      surname: 'Almase',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'archive',
      lastLoggedAt: '2025-02-24T09:20:53+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '410273',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '37122',
      email: 'georgette.amoranto@linxio.com',
      name: 'Georgette',
      surname: 'Amoranto',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+639916947876',
      status: 'active',
      lastLoggedAt: '2026-04-30T05:15:55+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '407690',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '36781',
      email: 'danny.le@linxio.com',
      name: 'Danny',
      surname: 'Le',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-30T09:44:26+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '350709',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '31953',
      email: 'aarslan@banyansoftware.com',
      name: 'Anum',
      surname: 'Arslan',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+16581615651',
      status: 'active',
      lastLoggedAt: '2025-08-25T05:27:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '10031',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '1580',
      email: 'dean.grey@linxio.com',
      name: 'Dean',
      surname: 'Grey',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61421777794',
      status: 'blocked',
      lastLoggedAt: '2023-01-22T00:42:43+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '50972',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '5024',
      email: 'dylan.tran@linxio.com1',
      name: 'Dylan',
      surname: 'Tran',
      role: {
        id: 5,
        name: 'support',
        displayName: 'Support',
      },
      phone: '+61423799688',
      status: 'blocked',
      lastLoggedAt: '2023-03-05T22:49:58+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '37440',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '4059',
      email: 'test-admin-team-create@linxio.com',
      name: 'test-admin-team-create@linxio.com',
      surname: 'test-admin-team-create@linxio.com',
      role: {
        id: 5,
        name: 'support',
        displayName: 'Support',
      },
      phone: '+11111111',
      status: 'archive',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '37420',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '4058',
      email: 'test-user-admin-team@linxio.com',
      name: 'test-user-admin-team@linxio.com',
      surname: 'test-user-admin-team@linxio.com',
      role: {
        id: 5,
        name: 'support',
        displayName: 'Support',
      },
      phone: '+11111111',
      status: 'archive',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '388162',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '34842',
      email: 'fahmed@banyansoftware.com',
      name: 'Farhan',
      surname: 'Ahmed',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+923452236224',
      status: 'active',
      lastLoggedAt: '2025-09-17T05:22:27+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '191619',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '19842',
      email: 'jimmy.mao@linxio.com',
      name: 'Jimmy',
      surname: 'Mao',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61416086580',
      status: 'active',
      lastLoggedAt: '2026-04-27T23:04:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '335766',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '30785',
      email: 'mmahboob@banyansoftware.com',
      name: 'Monaiza',
      surname: 'Mahboob',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+123456789',
      status: 'active',
      lastLoggedAt: '2025-08-26T02:11:48+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '406794',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '36664',
      email: 'howard.wong+accounts@linxio.com',
      name: 'Howard',
      surname: 'Wong',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+61422338080',
      status: 'new',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '409369',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '36964',
      email: 'judyann.rivero@linxio.com',
      name: 'Judyann',
      surname: 'Rivero',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+21451663163262',
      status: 'active',
      lastLoggedAt: '2026-04-30T04:52:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '409367',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '36963',
      email: 'chrisanne.batuyong@linxio.com',
      name: 'Chrisanne',
      surname: 'Batuyong',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+61234361351',
      status: 'active',
      lastLoggedAt: '2026-04-29T06:45:07+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '183906',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '19684',
      email: 'aila.santiago@linxio.com',
      name: 'Aila',
      surname: 'Santiago',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+321321321',
      status: 'active',
      lastLoggedAt: '2026-04-30T05:47:53+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: true,
  },
  {
    id: '135644',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '14971',
      email: 'sales+am@linxio.com',
      name: 'AM',
      surname: 'AM',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+123456789',
      status: 'deleted',
      lastLoggedAt: '2022-12-09T03:13:36+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationPopup',
    value: false,
  },
  {
    id: '53039',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '5202',
      email: 'developer+hs@linxio.com',
      name: 'Hanna',
      surname: 'Sh',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+375336700825',
      status: 'deleted',
      lastLoggedAt: '2024-06-28T05:36:40+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '12708',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '1786',
      email: 'developer+ak@linxio.com',
      name: 'Alexei',
      surname: 'K',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+375297624557',
      status: 'archive',
      lastLoggedAt: '2025-04-16T16:05:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '407818',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '19842',
      email: 'jimmy.mao@linxio.com',
      name: 'Jimmy',
      surname: 'Mao',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61416086580',
      status: 'active',
      lastLoggedAt: '2026-04-27T23:04:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '142495',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '20',
      email: 'developer+dk@linxio.com',
      name: 'Dmitry',
      surname: 'K',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+375447130716',
      status: 'archive',
      lastLoggedAt: '2024-06-27T10:17:10+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '324217',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '28770',
      email: 'dhen.mark@linxio.com',
      name: 'Dhen Mark',
      surname: 'Torreno',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+37382781',
      status: 'blocked',
      lastLoggedAt: '2025-01-16T05:15:30+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '49060',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '4786',
      email: 'sales+support@linxio.com',
      name: 'Linxio',
      surname: 'Support',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+123456789',
      status: 'blocked',
      lastLoggedAt: '2023-02-07T22:20:00+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '373594',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '11461',
      email: 'graham.carter@linxio.com',
      name: 'Graham',
      surname: 'Carter',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61413436249',
      status: 'active',
      lastLoggedAt: '2026-04-30T00:13:04+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '12598',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '1772',
      email: 'developer+at2@linxio.com',
      name: 'Alex',
      surname: 'T',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+375447966952',
      status: 'archive',
      lastLoggedAt: '2021-12-22T12:58:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '373590',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '16095',
      email: 'dylan.tran@linxio.com',
      name: 'Dylan',
      surname: 'Tran',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61423799688',
      status: 'active',
      lastLoggedAt: '2026-04-24T00:28:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '335012',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '30742',
      email: 'nitin13323@gmail.com',
      name: 'Nitin',
      surname: 'Kumar',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+917837379125',
      status: 'active',
      lastLoggedAt: '2025-07-29T09:22:21+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '8057',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '17',
      email: 'developer+sp@linxio.com',
      name: 'Serge',
      surname: 'P',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+375293231454',
      status: 'archive',
      lastLoggedAt: '2025-05-26T10:35:17+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '367814',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '3970',
      email: 'john.baldoria@linxio.com',
      name: 'John',
      surname: 'Baldoria',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61433649110',
      status: 'active',
      lastLoggedAt: '2026-04-29T23:50:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '356500',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '32387',
      email: 'jasper.sampang@linxio.com',
      name: 'Jasper',
      surname: 'Sampang',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+09052373445',
      status: 'active',
      lastLoggedAt: '2026-04-29T23:15:11+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '10357',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '1599',
      email: 'support@linxio.com',
      name: 'Support',
      surname: 'Support',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61419403003',
      status: 'blocked',
      lastLoggedAt: '2025-08-08T04:45:52+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '41182',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '4416',
      email: 'amesh.desilva@linxio.com',
      name: 'Amesh',
      surname: 'De Silva',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61401218936',
      status: 'blocked',
      lastLoggedAt: '2022-02-10T00:41:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '17053',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '2284',
      email: 'ramez.habib@linxio.com',
      name: 'Ramez',
      surname: 'Habib',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61402491285',
      status: 'archive',
      lastLoggedAt: '2024-09-26T00:08:21+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '19330',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '1580',
      email: 'dean.grey@linxio.com',
      name: 'Dean',
      surname: 'Grey',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61421777794',
      status: 'blocked',
      lastLoggedAt: '2023-01-22T00:42:43+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '37223',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '3970',
      email: 'john.baldoria@linxio.com',
      name: 'John',
      surname: 'Baldoria',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61433649110',
      status: 'active',
      lastLoggedAt: '2026-04-29T23:50:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '50411',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '4923',
      email: 'dennis+admin@linxio.com',
      name: 'Dennis',
      surname: 'Papadatos',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+123456789',
      status: 'new',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '51178',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '5056',
      email: 'william.mclean+admin@linxio.com',
      name: 'William',
      surname: 'McLean',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61417588235',
      status: 'blocked',
      lastLoggedAt: '2024-02-21T23:15:56+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '60470',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '5572',
      email: 'developer+kk@linxio.com',
      name: 'Kiryl',
      surname: 'K',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+375257794915',
      status: 'archive',
      lastLoggedAt: '2022-08-09T14:46:04+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '89146',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '5024',
      email: 'dylan.tran@linxio.com1',
      name: 'Dylan',
      surname: 'Tran',
      role: {
        id: 5,
        name: 'support',
        displayName: 'Support',
      },
      phone: '+61423799688',
      status: 'blocked',
      lastLoggedAt: '2023-03-05T22:49:58+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '279238',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '25265',
      email: 'daryl.lozanes@linxio.com',
      name: 'Daryl',
      surname: 'Lozanes',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-26T23:16:15+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '145289',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '16095',
      email: 'dylan.tran@linxio.com',
      name: 'Dylan',
      surname: 'Tran',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61423799688',
      status: 'active',
      lastLoggedAt: '2026-04-24T00:28:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '147230',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '16280',
      email: 'neil.carter@linxio.com',
      name: 'Neil',
      surname: 'Carter',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61406708626',
      status: 'blocked',
      lastLoggedAt: '2024-04-25T23:15:47+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '310077',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '27601',
      email: 'andrew.mercado@linxio.com',
      name: 'Andrew',
      surname: 'Mercado',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-28T23:40:31+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '264668',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '24397',
      email: 'monchou.dacumos@linxio.com',
      name: 'Monchou',
      surname: 'Dacumos',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+11111111',
      status: 'archive',
      lastLoggedAt: '2026-04-24T04:36:26+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '317327',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '28230',
      email: 'ellen.marie@linxio.com',
      name: 'Ellen',
      surname: 'Marie',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-29T23:09:17+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '260192',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '24056',
      email: 'genette.casas@linxio.com',
      name: 'Genette',
      surname: 'Casas',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+12345678',
      status: 'blocked',
      lastLoggedAt: '2024-07-31T13:36:57+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '292872',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '26268',
      email: 'marben.bagting@linxio.com',
      name: 'Marben',
      surname: 'Bagting',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-30T00:27:35+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '300030',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '26884',
      email: 'ezra.galacan@linxio.com',
      name: 'Ezra',
      surname: 'Galacan',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'deleted',
      lastLoggedAt: '2025-03-11T22:34:24+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '302051',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '27083',
      email: 'hiroshi.santos@linxio.com',
      name: 'Hiroshi',
      surname: 'Santos',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234564879797',
      status: 'archive',
      lastLoggedAt: '2024-09-02T10:26:17+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '308923',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '27515',
      email: 'pstrong@banyansoftware.com',
      name: 'Pippa',
      surname: 'Strong',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61123456',
      status: 'blocked',
      lastLoggedAt: '2025-03-24T03:57:59+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '308925',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '27516',
      email: 'tahmed@banyansoftware.com',
      name: 'Taha',
      surname: 'Ahmed',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61123456',
      status: 'deleted',
      lastLoggedAt: '2024-11-25T00:57:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '330347',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '29873',
      email: 'myint.oo@linxio.com',
      name: 'Myint',
      surname: 'Oo',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-27T06:24:02+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '339567',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '31161',
      email: 'ben.li@linxio.com',
      name: 'Ben',
      surname: 'Li',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61425290521',
      status: 'archive',
      lastLoggedAt: '2025-09-19T06:05:20+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '340971',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '31242',
      email: 'darwin.argulane@linxio.com',
      name: 'Darwin',
      surname: 'Argulane',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+639953090292',
      status: 'deleted',
      lastLoggedAt: '2025-04-10T01:21:16+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '353762',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '32206',
      email: 'thisbe.notarte@linxio.com',
      name: 'thisbe',
      surname: 'notarte',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+639365627315',
      status: 'blocked',
      lastLoggedAt: '2025-04-28T22:45:35+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '361177',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '32785',
      email: 'kate.allison@linxio.com',
      name: 'Kate',
      surname: 'Allison',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61413436249',
      status: 'archive',
      lastLoggedAt: '2026-02-19T22:53:43+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '365274',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '33037',
      email: 'pyaesone1732@gmail.com',
      name: 'Pyae',
      surname: 'Sone',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-02-26T04:59:35+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '365903',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '33067',
      email: 'vaibhavb13323@gmail.com',
      name: 'Vaibhav',
      surname: 'B',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-03-27T18:36:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '367863',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '25339',
      email: 'michelle.nonato@linxio.com',
      name: 'Michelle',
      surname: 'Nonato',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61111111',
      status: 'active',
      lastLoggedAt: '2025-12-19T03:22:18+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '392396',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '35422',
      email: 'bao.tran@linxio.com',
      name: 'Bao',
      surname: 'Tran',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-01-30T03:15:15+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '411781',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '37259',
      email: 'john.waine@linxio.com',
      name: 'John',
      surname: 'Waine',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+09676421733',
      status: 'active',
      lastLoggedAt: '2026-04-30T01:30:39+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '253186',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '23094',
      email: 'caleb.bacon@linxio.com',
      name: 'Caleb',
      surname: 'Bacon',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+61432154709',
      status: 'active',
      lastLoggedAt: '2026-04-28T04:30:58+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '59215',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '5399',
      email: 'joshuadodds@0.com',
      name: 'Joshua',
      surname: 'Dodds',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+123456798',
      status: 'deleted',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '410860',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '37162',
      email: 'luongviethai@linxio.com',
      name: 'Hai',
      surname: 'Viet Luong',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-21T01:38:18+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '59217',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '5400',
      email: 'meganfisquet@0.com',
      name: 'Megan',
      surname: 'Fisquet',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+123456789',
      status: 'deleted',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '24691',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '2950',
      email: 'sales@nxgentechs.com',
      name: 'Maria',
      surname: 'Mascarenhas',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+1234567890',
      status: 'blocked',
      lastLoggedAt: '2022-02-21T14:03:12+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '310232',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '27613',
      email: 'vanessa.crisante@linxio.com',
      name: 'Vanessa ',
      surname: 'Crisante',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+61497323054',
      status: 'active',
      lastLoggedAt: '2026-03-23T07:06:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '393696',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '35547',
      email: 'tim.barsoum@linxio.com',
      name: 'Tim',
      surname: 'Barsoum',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+123456789',
      status: 'active',
      lastLoggedAt: '2026-04-30T03:19:13+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '407693',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '36782',
      email: 'jimmy.mao+sales@linxio.com',
      name: 'Jimmy',
      surname: 'Mao',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+1234567',
      status: 'new',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '339563',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '31159',
      email: 'kevin.khuu@linxio.com',
      name: 'Kevin',
      surname: 'Khuu',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+61421675117',
      status: 'archive',
      lastLoggedAt: '2025-09-09T23:32:51+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '339565',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '31160',
      email: 'morgan.to@linxio.com',
      name: 'Morgan',
      surname: 'To',
      role: {
        id: 4,
        name: 'installer',
        displayName: 'Installer',
      },
      phone: '+61469336047',
      status: 'archive',
      lastLoggedAt: '2026-04-10T01:00:18+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '50885',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '4989',
      email: 'joshua.dodds@linxio.com',
      name: 'Joshua',
      surname: 'Dodds',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+123456789',
      status: 'deleted',
      lastLoggedAt: '2024-03-12T23:48:59+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '148108',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '16365',
      email: 'howard.wong@linxio.com',
      name: 'Howard',
      surname: 'Wong',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+61422338080',
      status: 'active',
      lastLoggedAt: '2026-04-30T01:02:02+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '171795',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '18503',
      email: 'aaqil.sahib@linxio.com',
      name: 'Aaqil',
      surname: 'Sahib',
      role: {
        id: 3,
        name: 'sales_rep',
        displayName: 'Sales Representative',
      },
      phone: '+61451254928',
      status: 'blocked',
      lastLoggedAt: '2024-02-29T00:51:58+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '410862',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: {
      id: '37163',
      email: 'linhnguyen@linxio.com',
      name: 'Linh',
      surname: 'Nguyen',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-30T03:47:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '200458',
    role: {
      id: 4,
      name: 'installer',
      displayName: 'Installer',
    },
    user: {
      id: '20322',
      email: 'nick+installer@linxio.com',
      name: 'Nick',
      surname: 'Bailey',
      role: {
        id: 4,
        name: 'installer',
        displayName: 'Installer',
      },
      phone: '+61423760909',
      status: 'archive',
      lastLoggedAt: '2023-10-13T06:24:04+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '398142',
    role: {
      id: 4,
      name: 'installer',
      displayName: 'Installer',
    },
    user: {
      id: '35979',
      email: 'dylan.tran+installer@linxio.com',
      name: 'Dylan',
      surname: 'Tran',
      role: {
        id: 4,
        name: 'installer',
        displayName: 'Installer',
      },
      phone: '+123456789',
      status: 'active',
      lastLoggedAt: '2025-11-26T02:53:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '9939',
    role: {
      id: 4,
      name: 'installer',
      displayName: 'Installer',
    },
    user: {
      id: '1570',
      email: 'hello@taskbranch.com',
      name: 'Task',
      surname: 'branch',
      role: {
        id: 4,
        name: 'installer',
        displayName: 'Installer',
      },
      phone: '+61419403003',
      status: 'archive',
      lastLoggedAt: '2021-02-02T09:10:26+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '389501',
    role: {
      id: 4,
      name: 'installer',
      displayName: 'Installer',
    },
    user: {
      id: '35016',
      email: 'george.qiang@linxio.com',
      name: 'George',
      surname: 'Zhi Quiang',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61466289467',
      status: 'active',
      lastLoggedAt: '2026-04-30T03:40:35+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '308735',
    role: {
      id: 4,
      name: 'installer',
      displayName: 'Installer',
    },
    user: {
      id: '27503',
      email: 'jimmy.mao.11.11@gmail.com',
      name: 'Jimmy',
      surname: 'installer',
      role: {
        id: 4,
        name: 'installer',
        displayName: 'Installer',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2024-10-11T00:24:56+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '104892',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '11461',
      email: 'graham.carter@linxio.com',
      name: 'Graham',
      surname: 'Carter',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61413436249',
      status: 'active',
      lastLoggedAt: '2026-04-30T00:13:04+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '10032',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '1580',
      email: 'dean.grey@linxio.com',
      name: 'Dean',
      surname: 'Grey',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61421777794',
      status: 'blocked',
      lastLoggedAt: '2023-01-22T00:42:43+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '279690',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '25339',
      email: 'michelle.nonato@linxio.com',
      name: 'Michelle',
      surname: 'Nonato',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61111111',
      status: 'active',
      lastLoggedAt: '2025-12-19T03:22:18+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '410274',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '37122',
      email: 'georgette.amoranto@linxio.com',
      name: 'Georgette',
      surname: 'Amoranto',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+639916947876',
      status: 'active',
      lastLoggedAt: '2026-04-30T05:15:55+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '304012',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '27215',
      email: 'ronnel.rana@linxio.com',
      name: 'Ronnel',
      surname: 'Rana',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'archive',
      lastLoggedAt: '2024-09-22T23:17:51+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '37421',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '4058',
      email: 'test-user-admin-team@linxio.com',
      name: 'test-user-admin-team@linxio.com',
      surname: 'test-user-admin-team@linxio.com',
      role: {
        id: 5,
        name: 'support',
        displayName: 'Support',
      },
      phone: '+11111111',
      status: 'archive',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '407691',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '36781',
      email: 'danny.le@linxio.com',
      name: 'Danny',
      surname: 'Le',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-30T09:44:26+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '350710',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '31953',
      email: 'aarslan@banyansoftware.com',
      name: 'Anum',
      surname: 'Arslan',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+16581615651',
      status: 'active',
      lastLoggedAt: '2025-08-25T05:27:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '37441',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '4059',
      email: 'test-admin-team-create@linxio.com',
      name: 'test-admin-team-create@linxio.com',
      surname: 'test-admin-team-create@linxio.com',
      role: {
        id: 5,
        name: 'support',
        displayName: 'Support',
      },
      phone: '+11111111',
      status: 'archive',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '50973',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '5024',
      email: 'dylan.tran@linxio.com1',
      name: 'Dylan',
      surname: 'Tran',
      role: {
        id: 5,
        name: 'support',
        displayName: 'Support',
      },
      phone: '+61423799688',
      status: 'blocked',
      lastLoggedAt: '2023-03-05T22:49:58+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '306835',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: {
      id: '27421',
      email: 'mark.almase@linxio.com',
      name: 'Mark',
      surname: 'Almase',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'archive',
      lastLoggedAt: '2025-02-24T09:20:53+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '388163',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '34842',
      email: 'fahmed@banyansoftware.com',
      name: 'Farhan',
      surname: 'Ahmed',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+923452236224',
      status: 'active',
      lastLoggedAt: '2025-09-17T05:22:27+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '406795',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '36664',
      email: 'howard.wong+accounts@linxio.com',
      name: 'Howard',
      surname: 'Wong',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+61422338080',
      status: 'new',
      lastLoggedAt: null,
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '183907',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '19684',
      email: 'aila.santiago@linxio.com',
      name: 'Aila',
      surname: 'Santiago',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+321321321',
      status: 'active',
      lastLoggedAt: '2026-04-30T05:47:53+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '335767',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '30785',
      email: 'mmahboob@banyansoftware.com',
      name: 'Monaiza',
      surname: 'Mahboob',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+123456789',
      status: 'active',
      lastLoggedAt: '2025-08-26T02:11:48+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '409368',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '36963',
      email: 'chrisanne.batuyong@linxio.com',
      name: 'Chrisanne',
      surname: 'Batuyong',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+61234361351',
      status: 'active',
      lastLoggedAt: '2026-04-29T06:45:07+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '135645',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '14971',
      email: 'sales+am@linxio.com',
      name: 'AM',
      surname: 'AM',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+123456789',
      status: 'deleted',
      lastLoggedAt: '2022-12-09T03:13:36+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: false,
  },
  {
    id: '409370',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '36964',
      email: 'judyann.rivero@linxio.com',
      name: 'Judyann',
      surname: 'Rivero',
      role: {
        id: 14,
        name: 'account_manager',
        displayName: 'Account Manager',
      },
      phone: '+21451663163262',
      status: 'active',
      lastLoggedAt: '2026-04-30T04:52:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '191620',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: {
      id: '19842',
      email: 'jimmy.mao@linxio.com',
      name: 'Jimmy',
      surname: 'Mao',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61416086580',
      status: 'active',
      lastLoggedAt: '2026-04-27T23:04:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'notificationSound',
    value: true,
  },
  {
    id: '49',
    role: null,
    user: null,
    name: 'notificationTemplate',
    value: 3,
  },
  {
    id: '39',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: null,
    name: 'otp',
    value: false,
  },
  {
    id: '40',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: null,
    name: 'otp',
    value: false,
  },
  {
    id: '41',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: null,
    name: 'otp',
    value: false,
  },
  {
    id: '42',
    role: {
      id: 4,
      name: 'installer',
      displayName: 'Installer',
    },
    user: null,
    name: 'otp',
    value: false,
  },
  {
    id: '43',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: null,
    name: 'otp',
    value: false,
  },
  {
    id: '50969',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: null,
    name: 'otp',
    value: false,
  },
  {
    id: '55',
    role: null,
    user: null,
    name: 'overSpeedingDuration',
    value: {
      value: 120,
    },
  },
  {
    id: '58',
    role: null,
    user: null,
    name: 'provider',
    value: 3,
  },
  {
    id: '110617',
    role: null,
    user: null,
    name: 'reports',
    value: [],
  },
  {
    id: '150771',
    role: null,
    user: null,
    name: 'routeOptimization',
    value: false,
  },
  {
    id: '154052',
    role: null,
    user: null,
    name: 'routeScope',
    value: {
      value: 'uncategorised',
    },
  },
  {
    id: '44',
    role: null,
    user: null,
    name: 'sms',
    value: true,
  },
  {
    id: '407819',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '19842',
      email: 'jimmy.mao@linxio.com',
      name: 'Jimmy',
      surname: 'Mao',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61416086580',
      status: 'active',
      lastLoggedAt: '2026-04-27T23:04:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'soundVolume',
    value: 'Default',
  },
  {
    id: '367815',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '3970',
      email: 'john.baldoria@linxio.com',
      name: 'John',
      surname: 'Baldoria',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61433649110',
      status: 'active',
      lastLoggedAt: '2026-04-29T23:50:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'soundVolume',
    value: 'Default',
  },
  {
    id: '373591',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '16095',
      email: 'dylan.tran@linxio.com',
      name: 'Dylan',
      surname: 'Tran',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61423799688',
      status: 'active',
      lastLoggedAt: '2026-04-24T00:28:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'soundVolume',
    value: 'Default',
  },
  {
    id: '358876',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: null,
    name: 'soundVolume',
    value: null,
  },
  {
    id: '373595',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '11461',
      email: 'graham.carter@linxio.com',
      name: 'Graham',
      surname: 'Carter',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61413436249',
      status: 'active',
      lastLoggedAt: '2026-04-30T00:13:04+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'soundVolume',
    value: 'Default',
  },
  {
    id: '368594',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '29873',
      email: 'myint.oo@linxio.com',
      name: 'Myint',
      surname: 'Oo',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-27T06:24:02+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'soundVolume',
    value: 'Default',
  },
  {
    id: '358877',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: null,
    name: 'soundVolume',
    value: null,
  },
  {
    id: '363961',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '24397',
      email: 'monchou.dacumos@linxio.com',
      name: 'Monchou',
      surname: 'Dacumos',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+11111111',
      status: 'archive',
      lastLoggedAt: '2026-04-24T04:36:26+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'soundVolume',
    value: 'Default',
  },
  {
    id: '367811',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '33067',
      email: 'vaibhavb13323@gmail.com',
      name: 'Vaibhav',
      surname: 'B',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-03-27T18:36:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'soundVolume',
    value: 'Default',
  },
  {
    id: '367864',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '25339',
      email: 'michelle.nonato@linxio.com',
      name: 'Michelle',
      surname: 'Nonato',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61111111',
      status: 'active',
      lastLoggedAt: '2025-12-19T03:22:18+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'soundVolume',
    value: 'Default',
  },
  {
    id: '358875',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: null,
    name: 'soundVolume',
    value: null,
  },
  {
    id: '358878',
    role: {
      id: 4,
      name: 'installer',
      displayName: 'Installer',
    },
    user: null,
    name: 'soundVolume',
    value: null,
  },
  {
    id: '358879',
    role: {
      id: 5,
      name: 'support',
      displayName: 'Support',
    },
    user: null,
    name: 'soundVolume',
    value: null,
  },
  {
    id: '358874',
    role: {
      id: 14,
      name: 'account_manager',
      displayName: 'Account Manager',
    },
    user: null,
    name: 'soundVolume',
    value: null,
  },
  {
    id: '47',
    role: null,
    user: null,
    name: 'theme',
    value: {
      id: 5,
      name: 'Light Theme',
      accentColor: '#512da8',
      primaryBackgroundColor: '#ffffff',
      secondaryBackgroundColor: '#f4f8f9',
      menuBackgroundColor: '#110A21',
      primaryBorderColor: '#ced4db',
      primaryFontColor: 'black',
      secondaryFontColor: '#7a7a7a',
      logoSrc: '/assets/images/logo-light.svg',
    },
  },
  {
    id: '172628',
    role: null,
    user: null,
    name: 'time12h',
    value: false,
  },
  {
    id: '367816',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '3970',
      email: 'john.baldoria@linxio.com',
      name: 'John',
      surname: 'Baldoria',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61433649110',
      status: 'active',
      lastLoggedAt: '2026-04-29T23:50:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'timezone',
    value: 1166,
  },
  {
    id: '407820',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '19842',
      email: 'jimmy.mao@linxio.com',
      name: 'Jimmy',
      surname: 'Mao',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61416086580',
      status: 'active',
      lastLoggedAt: '2026-04-27T23:04:50+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'timezone',
    value: 1166,
  },
  {
    id: '373592',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '16095',
      email: 'dylan.tran@linxio.com',
      name: 'Dylan',
      surname: 'Tran',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61423799688',
      status: 'active',
      lastLoggedAt: '2026-04-24T00:28:19+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'timezone',
    value: 1166,
  },
  {
    id: '373596',
    role: {
      id: 1,
      name: 'super_admin',
      displayName: 'SuperAdmin',
    },
    user: {
      id: '11461',
      email: 'graham.carter@linxio.com',
      name: 'Graham',
      surname: 'Carter',
      role: {
        id: 1,
        name: 'super_admin',
        displayName: 'SuperAdmin',
      },
      phone: '+61413436249',
      status: 'active',
      lastLoggedAt: '2026-04-30T00:13:04+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'timezone',
    value: 1166,
  },
  {
    id: '367865',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '25339',
      email: 'michelle.nonato@linxio.com',
      name: 'Michelle',
      surname: 'Nonato',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+61111111',
      status: 'active',
      lastLoggedAt: '2025-12-19T03:22:18+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'timezone',
    value: 1166,
  },
  {
    id: '264724',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '24397',
      email: 'monchou.dacumos@linxio.com',
      name: 'Monchou',
      surname: 'Dacumos',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+11111111',
      status: 'archive',
      lastLoggedAt: '2026-04-24T04:36:26+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'timezone',
    value: 1166,
  },
  {
    id: '367812',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '33067',
      email: 'vaibhavb13323@gmail.com',
      name: 'Vaibhav',
      surname: 'B',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-03-27T18:36:08+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'timezone',
    value: 1164,
  },
  {
    id: '368595',
    role: {
      id: 2,
      name: 'admin',
      displayName: 'Admin',
    },
    user: {
      id: '29873',
      email: 'myint.oo@linxio.com',
      name: 'Myint',
      surname: 'Oo',
      role: {
        id: 2,
        name: 'admin',
        displayName: 'Admin',
      },
      phone: '+1234567',
      status: 'active',
      lastLoggedAt: '2026-04-27T06:24:02+00:00',
      driverSensorId: null,
      driverFOBId: null,
    },
    name: 'timezone',
    value: 1073,
  },
  {
    id: '150297',
    role: {
      id: 3,
      name: 'sales_rep',
      displayName: 'Sales Representative',
    },
    user: null,
    name: 'timezone',
    value: 1166,
  },
  {
    id: '60',
    role: null,
    user: null,
    name: 'timezone',
    value: 1109,
  },
  {
    id: '2642',
    role: null,
    user: null,
    name: 'trackingLink',
    value: false,
  },
  {
    id: '2754',
    role: null,
    user: null,
    name: 'trackingLinkDefaultMessage',
    value: '',
  },
  {
    id: '188187',
    role: null,
    user: null,
    name: 'tripCode',
    value: false,
  },
  {
    id: '180662',
    role: null,
    user: null,
    name: 'userAutoLogoutOption',
    value: {
      value: 3600,
      enable: false,
    },
  },
  {
    id: '200542',
    role: null,
    user: null,
    name: 'userLocalAuthOption',
    value: {
      value: null,
      enable: false,
    },
  },
  {
    id: '183916',
    role: null,
    user: null,
    name: 'userTermsAcceptance',
    value: false,
  },
  {
    id: '53',
    role: null,
    user: null,
    name: 'vehicleEngineOff',
    value: {
      value: 300,
      enable: false,
    },
  },
  {
    id: '36223',
    role: null,
    user: null,
    name: 'vehicleMapFieldWithIcon',
    value: 'titleAndRegno',
  },
  {
    id: '35309',
    role: null,
    user: null,
    name: 'vehicleMapTitleInsteadOfRegno',
    value: false,
  },
  {
    id: '129350',
    role: null,
    user: null,
    name: 'xeroEnabled',
    value: true,
  },
]

export const FALLBACK_ADMIN_PLATFORM_SETTINGS = {
  id: 3,
  currency: { id: 1, name: 'Australian dollar', code: 'AUD', symbol: '$', decimals: 2 },
  logo: null,
  domain: 'linxio.com',
  units: null,
  supportPhone: '+61279085450',
  emailName: 'Linxio',
  smsName: 'Linxio',
  favicon: null,
  supportMsg: '9am to 5pm AEST',
  supportEmail: 'support@linxio.com',
  clientDefaultTheme: {
    id: 5,
    name: 'Light Theme',
    accentColor: '#512da8',
    primaryBackgroundColor: '#ffffff',
    secondaryBackgroundColor: '#f4f8f9',
    menuBackgroundColor: '#110A21',
    primaryBorderColor: '#ced4db',
    primaryFontColor: 'black',
    secondaryFontColor: '#7a7a7a',
    logoSrc: '/assets/images/logo-light.svg',
  },
  productName: 'Linxio',
  notificationEmail: 'notifications@linxio.com',
  linkAppStore: 'https://apps.apple.com/us/app/linxio/id1504048898',
  linkPlayMarket: 'https://play.google.com/store/apps/details?id=com.linxio.mobile',
  linkKnowledgeBase: 'https://kb.linxio.com/en',
  intercomId: 'lkh51a74',
  accountingEmail: 'accounts@linxio.com',
  hostApi: null,
  hostApp: null,
  hostTrack: null,
  hostMessenger: null,
  salesEmail: null,
  privacyPolicyLink: null,
  termsOfUseLink: null,
}

export const FALLBACK_ADMIN_INFO = {
  companyName: 'Ready Track Pty Ltd',
  legalName: 'Linxio',
  abn: '64166623981',
  legalAddress: 'Sydney Olympic Park NSW 2127 // Suite 1.02/102 Bennelong Parkway',
  billingAddress: 'Sydney Olympic Park NSW 2127 // Suite 1.02/102 Bennelong Parkway',
}

export const FALLBACK_PLANS = [
  {
    id: 1,
    name: 'starter',
    displayName: 'Starter',
  },
  {
    id: 2,
    name: 'fleet_essentials',
    displayName: 'Fleet Essentials',
  },
  {
    id: 3,
    name: 'fleet_plus',
    displayName: 'Fleet Plus',
  },
]

export const FALLBACK_TIMEZONES = [
  {
    id: 1259,
    displayName: '(UTC-11:00) Pacific/Midway',
    name: 'Pacific/Midway',
  },
  {
    id: 1261,
    displayName: '(UTC-11:00) Pacific/Niue',
    name: 'Pacific/Niue',
  },
  {
    id: 1264,
    displayName: '(UTC-11:00) Pacific/Pago_Pago',
    name: 'Pacific/Pago_Pago',
  },
  {
    id: 1253,
    displayName: '(UTC-10:00) Pacific/Honolulu',
    name: 'Pacific/Honolulu',
  },
  {
    id: 1269,
    displayName: '(UTC-10:00) Pacific/Rarotonga',
    name: 'Pacific/Rarotonga',
  },
  {
    id: 1271,
    displayName: '(UTC-10:00) Pacific/Tahiti',
    name: 'Pacific/Tahiti',
  },
  {
    id: 1258,
    displayName: '(UTC-10:30) Pacific/Marquesas',
    name: 'Pacific/Marquesas',
  },
  {
    id: 903,
    displayName: '(UTC-09:00) America/Adak',
    name: 'America/Adak',
  },
  {
    id: 1250,
    displayName: '(UTC-09:00) Pacific/Gambier',
    name: 'Pacific/Gambier',
  },
  {
    id: 904,
    displayName: '(UTC-08:00) America/Anchorage',
    name: 'America/Anchorage',
  },
  {
    id: 978,
    displayName: '(UTC-08:00) America/Juneau',
    name: 'America/Juneau',
  },
  {
    id: 995,
    displayName: '(UTC-08:00) America/Metlakatla',
    name: 'America/Metlakatla',
  },
  {
    id: 1005,
    displayName: '(UTC-08:00) America/Nome',
    name: 'America/Nome',
  },
  {
    id: 1031,
    displayName: '(UTC-08:00) America/Sitka',
    name: 'America/Sitka',
  },
  {
    id: 1048,
    displayName: '(UTC-08:00) America/Yakutat',
    name: 'America/Yakutat',
  },
  {
    id: 1266,
    displayName: '(UTC-08:00) Pacific/Pitcairn',
    name: 'Pacific/Pitcairn',
  },
  {
    id: 941,
    displayName: '(UTC-07:00) America/Creston',
    name: 'America/Creston',
  },
  {
    id: 945,
    displayName: '(UTC-07:00) America/Dawson',
    name: 'America/Dawson',
  },
  {
    id: 946,
    displayName: '(UTC-07:00) America/Dawson_Creek',
    name: 'America/Dawson_Creek',
  },
  {
    id: 953,
    displayName: '(UTC-07:00) America/Fort_Nelson',
    name: 'America/Fort_Nelson',
  },
  {
    id: 966,
    displayName: '(UTC-07:00) America/Hermosillo',
    name: 'America/Hermosillo',
  },
  {
    id: 984,
    displayName: '(UTC-07:00) America/Los_Angeles',
    name: 'America/Los_Angeles',
  },
  {
    id: 992,
    displayName: '(UTC-07:00) America/Mazatlan',
    name: 'America/Mazatlan',
  },
  {
    id: 1014,
    displayName: '(UTC-07:00) America/Phoenix',
    name: 'America/Phoenix',
  },
  {
    id: 1042,
    displayName: '(UTC-07:00) America/Tijuana',
    name: 'America/Tijuana',
  },
  {
    id: 1045,
    displayName: '(UTC-07:00) America/Vancouver',
    name: 'America/Vancouver',
  },
  {
    id: 1046,
    displayName: '(UTC-07:00) America/Whitehorse',
    name: 'America/Whitehorse',
  },
  {
    id: 924,
    displayName: '(UTC-06:00) America/Bahia_Banderas',
    name: 'America/Bahia_Banderas',
  },
  {
    id: 927,
    displayName: '(UTC-06:00) America/Belize',
    name: 'America/Belize',
  },
  {
    id: 931,
    displayName: '(UTC-06:00) America/Boise',
    name: 'America/Boise',
  },
  {
    id: 932,
    displayName: '(UTC-06:00) America/Cambridge_Bay',
    name: 'America/Cambridge_Bay',
  },
  {
    id: 939,
    displayName: '(UTC-06:00) America/Chihuahua',
    name: 'America/Chihuahua',
  },
  {
    id: 1282,
    displayName: '(UTC-06:00) America/Ciudad_Juarez',
    name: 'America/Ciudad_Juarez',
  },
  {
    id: 940,
    displayName: '(UTC-06:00) America/Costa_Rica',
    name: 'America/Costa_Rica',
  },
  {
    id: 947,
    displayName: '(UTC-06:00) America/Denver',
    name: 'America/Denver',
  },
  {
    id: 950,
    displayName: '(UTC-06:00) America/Edmonton',
    name: 'America/Edmonton',
  },
  {
    id: 952,
    displayName: '(UTC-06:00) America/El_Salvador',
    name: 'America/El_Salvador',
  },
  {
    id: 961,
    displayName: '(UTC-06:00) America/Guatemala',
    name: 'America/Guatemala',
  },
  {
    id: 975,
    displayName: '(UTC-06:00) America/Inuvik',
    name: 'America/Inuvik',
  },
  {
    id: 987,
    displayName: '(UTC-06:00) America/Managua',
    name: 'America/Managua',
  },
  {
    id: 994,
    displayName: '(UTC-06:00) America/Merida',
    name: 'America/Merida',
  },
  {
    id: 996,
    displayName: '(UTC-06:00) America/Mexico_City',
    name: 'America/Mexico_City',
  },
  {
    id: 999,
    displayName: '(UTC-06:00) America/Monterrey',
    name: 'America/Monterrey',
  },
  {
    id: 1023,
    displayName: '(UTC-06:00) America/Regina',
    name: 'America/Regina',
  },
  {
    id: 1038,
    displayName: '(UTC-06:00) America/Swift_Current',
    name: 'America/Swift_Current',
  },
  {
    id: 1039,
    displayName: '(UTC-06:00) America/Tegucigalpa',
    name: 'America/Tegucigalpa',
  },
  {
    id: 1049,
    displayName: '(UTC-06:00) America/Yellowknife',
    name: 'America/Yellowknife',
  },
  {
    id: 1243,
    displayName: '(UTC-06:00) Pacific/Easter',
    name: 'Pacific/Easter',
  },
  {
    id: 1249,
    displayName: '(UTC-06:00) Pacific/Galapagos',
    name: 'Pacific/Galapagos',
  },
  {
    id: 922,
    displayName: '(UTC-05:00) America/Atikokan',
    name: 'America/Atikokan',
  },
  {
    id: 930,
    displayName: '(UTC-05:00) America/Bogota',
    name: 'America/Bogota',
  },
  {
    id: 934,
    displayName: '(UTC-05:00) America/Cancun',
    name: 'America/Cancun',
  },
  {
    id: 937,
    displayName: '(UTC-05:00) America/Cayman',
    name: 'America/Cayman',
  },
  {
    id: 938,
    displayName: '(UTC-05:00) America/Chicago',
    name: 'America/Chicago',
  },
  {
    id: 951,
    displayName: '(UTC-05:00) America/Eirunepe',
    name: 'America/Eirunepe',
  },
  {
    id: 962,
    displayName: '(UTC-05:00) America/Guayaquil',
    name: 'America/Guayaquil',
  },
  {
    id: 968,
    displayName: '(UTC-05:00) America/Indiana/Knox',
    name: 'America/Indiana/Knox',
  },
  {
    id: 971,
    displayName: '(UTC-05:00) America/Indiana/Tell_City',
    name: 'America/Indiana/Tell_City',
  },
  {
    id: 977,
    displayName: '(UTC-05:00) America/Jamaica',
    name: 'America/Jamaica',
  },
  {
    id: 983,
    displayName: '(UTC-05:00) America/Lima',
    name: 'America/Lima',
  },
  {
    id: 991,
    displayName: '(UTC-05:00) America/Matamoros',
    name: 'America/Matamoros',
  },
  {
    id: 993,
    displayName: '(UTC-05:00) America/Menominee',
    name: 'America/Menominee',
  },
  {
    id: 1007,
    displayName: '(UTC-05:00) America/North_Dakota/Beulah',
    name: 'America/North_Dakota/Beulah',
  },
  {
    id: 1008,
    displayName: '(UTC-05:00) America/North_Dakota/Center',
    name: 'America/North_Dakota/Center',
  },
  {
    id: 1009,
    displayName: '(UTC-05:00) America/North_Dakota/New_Salem',
    name: 'America/North_Dakota/New_Salem',
  },
  {
    id: 1010,
    displayName: '(UTC-05:00) America/Ojinaga',
    name: 'America/Ojinaga',
  },
  {
    id: 1011,
    displayName: '(UTC-05:00) America/Panama',
    name: 'America/Panama',
  },
  {
    id: 1020,
    displayName: '(UTC-05:00) America/Rainy_River',
    name: 'America/Rainy_River',
  },
  {
    id: 1021,
    displayName: '(UTC-05:00) America/Rankin_Inlet',
    name: 'America/Rankin_Inlet',
  },
  {
    id: 1024,
    displayName: '(UTC-05:00) America/Resolute',
    name: 'America/Resolute',
  },
  {
    id: 1025,
    displayName: '(UTC-05:00) America/Rio_Branco',
    name: 'America/Rio_Branco',
  },
  {
    id: 1047,
    displayName: '(UTC-05:00) America/Winnipeg',
    name: 'America/Winnipeg',
  },
  {
    id: 905,
    displayName: '(UTC-04:00) America/Anguilla',
    name: 'America/Anguilla',
  },
  {
    id: 906,
    displayName: '(UTC-04:00) America/Antigua',
    name: 'America/Antigua',
  },
  {
    id: 920,
    displayName: '(UTC-04:00) America/Aruba',
    name: 'America/Aruba',
  },
  {
    id: 921,
    displayName: '(UTC-04:00) America/Asuncion',
    name: 'America/Asuncion',
  },
  {
    id: 925,
    displayName: '(UTC-04:00) America/Barbados',
    name: 'America/Barbados',
  },
  {
    id: 928,
    displayName: '(UTC-04:00) America/Blanc-Sablon',
    name: 'America/Blanc-Sablon',
  },
  {
    id: 929,
    displayName: '(UTC-04:00) America/Boa_Vista',
    name: 'America/Boa_Vista',
  },
  {
    id: 933,
    displayName: '(UTC-04:00) America/Campo_Grande',
    name: 'America/Campo_Grande',
  },
  {
    id: 935,
    displayName: '(UTC-04:00) America/Caracas',
    name: 'America/Caracas',
  },
  {
    id: 942,
    displayName: '(UTC-04:00) America/Cuiaba',
    name: 'America/Cuiaba',
  },
  {
    id: 943,
    displayName: '(UTC-04:00) America/Curacao',
    name: 'America/Curacao',
  },
  {
    id: 948,
    displayName: '(UTC-04:00) America/Detroit',
    name: 'America/Detroit',
  },
  {
    id: 949,
    displayName: '(UTC-04:00) America/Dominica',
    name: 'America/Dominica',
  },
  {
    id: 958,
    displayName: '(UTC-04:00) America/Grand_Turk',
    name: 'America/Grand_Turk',
  },
  {
    id: 959,
    displayName: '(UTC-04:00) America/Grenada',
    name: 'America/Grenada',
  },
  {
    id: 960,
    displayName: '(UTC-04:00) America/Guadeloupe',
    name: 'America/Guadeloupe',
  },
  {
    id: 963,
    displayName: '(UTC-04:00) America/Guyana',
    name: 'America/Guyana',
  },
  {
    id: 965,
    displayName: '(UTC-04:00) America/Havana',
    name: 'America/Havana',
  },
  {
    id: 967,
    displayName: '(UTC-04:00) America/Indiana/Indianapolis',
    name: 'America/Indiana/Indianapolis',
  },
  {
    id: 969,
    displayName: '(UTC-04:00) America/Indiana/Marengo',
    name: 'America/Indiana/Marengo',
  },
  {
    id: 970,
    displayName: '(UTC-04:00) America/Indiana/Petersburg',
    name: 'America/Indiana/Petersburg',
  },
  {
    id: 972,
    displayName: '(UTC-04:00) America/Indiana/Vevay',
    name: 'America/Indiana/Vevay',
  },
  {
    id: 973,
    displayName: '(UTC-04:00) America/Indiana/Vincennes',
    name: 'America/Indiana/Vincennes',
  },
  {
    id: 974,
    displayName: '(UTC-04:00) America/Indiana/Winamac',
    name: 'America/Indiana/Winamac',
  },
  {
    id: 976,
    displayName: '(UTC-04:00) America/Iqaluit',
    name: 'America/Iqaluit',
  },
  {
    id: 979,
    displayName: '(UTC-04:00) America/Kentucky/Louisville',
    name: 'America/Kentucky/Louisville',
  },
  {
    id: 980,
    displayName: '(UTC-04:00) America/Kentucky/Monticello',
    name: 'America/Kentucky/Monticello',
  },
  {
    id: 981,
    displayName: '(UTC-04:00) America/Kralendijk',
    name: 'America/Kralendijk',
  },
  {
    id: 982,
    displayName: '(UTC-04:00) America/La_Paz',
    name: 'America/La_Paz',
  },
  {
    id: 985,
    displayName: '(UTC-04:00) America/Lower_Princes',
    name: 'America/Lower_Princes',
  },
  {
    id: 988,
    displayName: '(UTC-04:00) America/Manaus',
    name: 'America/Manaus',
  },
  {
    id: 989,
    displayName: '(UTC-04:00) America/Marigot',
    name: 'America/Marigot',
  },
  {
    id: 990,
    displayName: '(UTC-04:00) America/Martinique',
    name: 'America/Martinique',
  },
  {
    id: 1001,
    displayName: '(UTC-04:00) America/Montserrat',
    name: 'America/Montserrat',
  },
  {
    id: 1002,
    displayName: '(UTC-04:00) America/Nassau',
    name: 'America/Nassau',
  },
  {
    id: 1003,
    displayName: '(UTC-04:00) America/New_York',
    name: 'America/New_York',
  },
  {
    id: 1004,
    displayName: '(UTC-04:00) America/Nipigon',
    name: 'America/Nipigon',
  },
  {
    id: 1012,
    displayName: '(UTC-04:00) America/Pangnirtung',
    name: 'America/Pangnirtung',
  },
  {
    id: 1015,
    displayName: '(UTC-04:00) America/Port-au-Prince',
    name: 'America/Port-au-Prince',
  },
  {
    id: 1016,
    displayName: '(UTC-04:00) America/Port_of_Spain',
    name: 'America/Port_of_Spain',
  },
  {
    id: 1017,
    displayName: '(UTC-04:00) America/Porto_Velho',
    name: 'America/Porto_Velho',
  },
  {
    id: 1018,
    displayName: '(UTC-04:00) America/Puerto_Rico',
    name: 'America/Puerto_Rico',
  },
  {
    id: 1027,
    displayName: '(UTC-04:00) America/Santiago',
    name: 'America/Santiago',
  },
  {
    id: 1028,
    displayName: '(UTC-04:00) America/Santo_Domingo',
    name: 'America/Santo_Domingo',
  },
  {
    id: 1032,
    displayName: '(UTC-04:00) America/St_Barthelemy',
    name: 'America/St_Barthelemy',
  },
  {
    id: 1034,
    displayName: '(UTC-04:00) America/St_Kitts',
    name: 'America/St_Kitts',
  },
  {
    id: 1035,
    displayName: '(UTC-04:00) America/St_Lucia',
    name: 'America/St_Lucia',
  },
  {
    id: 1036,
    displayName: '(UTC-04:00) America/St_Thomas',
    name: 'America/St_Thomas',
  },
  {
    id: 1037,
    displayName: '(UTC-04:00) America/St_Vincent',
    name: 'America/St_Vincent',
  },
  {
    id: 1041,
    displayName: '(UTC-04:00) America/Thunder_Bay',
    name: 'America/Thunder_Bay',
  },
  {
    id: 1043,
    displayName: '(UTC-04:00) America/Toronto',
    name: 'America/Toronto',
  },
  {
    id: 1044,
    displayName: '(UTC-04:00) America/Tortola',
    name: 'America/Tortola',
  },
  {
    id: 907,
    displayName: '(UTC-03:00) America/Araguaina',
    name: 'America/Araguaina',
  },
  {
    id: 908,
    displayName: '(UTC-03:00) America/Argentina/Buenos_Aires',
    name: 'America/Argentina/Buenos_Aires',
  },
  {
    id: 909,
    displayName: '(UTC-03:00) America/Argentina/Catamarca',
    name: 'America/Argentina/Catamarca',
  },
  {
    id: 910,
    displayName: '(UTC-03:00) America/Argentina/Cordoba',
    name: 'America/Argentina/Cordoba',
  },
  {
    id: 911,
    displayName: '(UTC-03:00) America/Argentina/Jujuy',
    name: 'America/Argentina/Jujuy',
  },
  {
    id: 912,
    displayName: '(UTC-03:00) America/Argentina/La_Rioja',
    name: 'America/Argentina/La_Rioja',
  },
  {
    id: 913,
    displayName: '(UTC-03:00) America/Argentina/Mendoza',
    name: 'America/Argentina/Mendoza',
  },
  {
    id: 914,
    displayName: '(UTC-03:00) America/Argentina/Rio_Gallegos',
    name: 'America/Argentina/Rio_Gallegos',
  },
  {
    id: 915,
    displayName: '(UTC-03:00) America/Argentina/Salta',
    name: 'America/Argentina/Salta',
  },
  {
    id: 916,
    displayName: '(UTC-03:00) America/Argentina/San_Juan',
    name: 'America/Argentina/San_Juan',
  },
  {
    id: 917,
    displayName: '(UTC-03:00) America/Argentina/San_Luis',
    name: 'America/Argentina/San_Luis',
  },
  {
    id: 918,
    displayName: '(UTC-03:00) America/Argentina/Tucuman',
    name: 'America/Argentina/Tucuman',
  },
  {
    id: 919,
    displayName: '(UTC-03:00) America/Argentina/Ushuaia',
    name: 'America/Argentina/Ushuaia',
  },
  {
    id: 923,
    displayName: '(UTC-03:00) America/Bahia',
    name: 'America/Bahia',
  },
  {
    id: 926,
    displayName: '(UTC-03:00) America/Belem',
    name: 'America/Belem',
  },
  {
    id: 936,
    displayName: '(UTC-03:00) America/Cayenne',
    name: 'America/Cayenne',
  },
  {
    id: 954,
    displayName: '(UTC-03:00) America/Fortaleza',
    name: 'America/Fortaleza',
  },
  {
    id: 955,
    displayName: '(UTC-03:00) America/Glace_Bay',
    name: 'America/Glace_Bay',
  },
  {
    id: 957,
    displayName: '(UTC-03:00) America/Goose_Bay',
    name: 'America/Goose_Bay',
  },
  {
    id: 964,
    displayName: '(UTC-03:00) America/Halifax',
    name: 'America/Halifax',
  },
  {
    id: 986,
    displayName: '(UTC-03:00) America/Maceio',
    name: 'America/Maceio',
  },
  {
    id: 998,
    displayName: '(UTC-03:00) America/Moncton',
    name: 'America/Moncton',
  },
  {
    id: 1000,
    displayName: '(UTC-03:00) America/Montevideo',
    name: 'America/Montevideo',
  },
  {
    id: 1013,
    displayName: '(UTC-03:00) America/Paramaribo',
    name: 'America/Paramaribo',
  },
  {
    id: 1019,
    displayName: '(UTC-03:00) America/Punta_Arenas',
    name: 'America/Punta_Arenas',
  },
  {
    id: 1022,
    displayName: '(UTC-03:00) America/Recife',
    name: 'America/Recife',
  },
  {
    id: 1026,
    displayName: '(UTC-03:00) America/Santarem',
    name: 'America/Santarem',
  },
  {
    id: 1029,
    displayName: '(UTC-03:00) America/Sao_Paulo',
    name: 'America/Sao_Paulo',
  },
  {
    id: 1040,
    displayName: '(UTC-03:00) America/Thule',
    name: 'America/Thule',
  },
  {
    id: 1056,
    displayName: '(UTC-03:00) Antarctica/Palmer',
    name: 'Antarctica/Palmer',
  },
  {
    id: 1057,
    displayName: '(UTC-03:00) Antarctica/Rothera',
    name: 'Antarctica/Rothera',
  },
  {
    id: 1146,
    displayName: '(UTC-03:00) Atlantic/Bermuda',
    name: 'Atlantic/Bermuda',
  },
  {
    id: 1154,
    displayName: '(UTC-03:00) Atlantic/Stanley',
    name: 'Atlantic/Stanley',
  },
  {
    id: 1033,
    displayName: '(UTC-03:30) America/St_Johns',
    name: 'America/St_Johns',
  },
  {
    id: 997,
    displayName: '(UTC-02:00) America/Miquelon',
    name: 'America/Miquelon',
  },
  {
    id: 1006,
    displayName: '(UTC-02:00) America/Noronha',
    name: 'America/Noronha',
  },
  {
    id: 1152,
    displayName: '(UTC-02:00) Atlantic/South_Georgia',
    name: 'Atlantic/South_Georgia',
  },
  {
    id: 956,
    displayName: '(UTC-01:00) America/Godthab',
    name: 'America/Godthab',
  },
  {
    id: 1276,
    displayName: '(UTC-01:00) America/Nuuk',
    name: 'America/Nuuk',
  },
  {
    id: 1030,
    displayName: '(UTC-01:00) America/Scoresbysund',
    name: 'America/Scoresbysund',
  },
  {
    id: 1148,
    displayName: '(UTC-01:00) Atlantic/Cape_Verde',
    name: 'Atlantic/Cape_Verde',
  },
  {
    id: 851,
    displayName: '(UTC+00:00) Africa/Abidjan',
    name: 'Africa/Abidjan',
  },
  {
    id: 852,
    displayName: '(UTC+00:00) Africa/Accra',
    name: 'Africa/Accra',
  },
  {
    id: 856,
    displayName: '(UTC+00:00) Africa/Bamako',
    name: 'Africa/Bamako',
  },
  {
    id: 858,
    displayName: '(UTC+00:00) Africa/Banjul',
    name: 'Africa/Banjul',
  },
  {
    id: 859,
    displayName: '(UTC+00:00) Africa/Bissau',
    name: 'Africa/Bissau',
  },
  {
    id: 866,
    displayName: '(UTC+00:00) Africa/Conakry',
    name: 'Africa/Conakry',
  },
  {
    id: 867,
    displayName: '(UTC+00:00) Africa/Dakar',
    name: 'Africa/Dakar',
  },
  {
    id: 872,
    displayName: '(UTC+00:00) Africa/Freetown',
    name: 'Africa/Freetown',
  },
  {
    id: 883,
    displayName: '(UTC+00:00) Africa/Lome',
    name: 'Africa/Lome',
  },
  {
    id: 892,
    displayName: '(UTC+00:00) Africa/Monrovia',
    name: 'Africa/Monrovia',
  },
  {
    id: 896,
    displayName: '(UTC+00:00) Africa/Nouakchott',
    name: 'Africa/Nouakchott',
  },
  {
    id: 897,
    displayName: '(UTC+00:00) Africa/Ouagadougou',
    name: 'Africa/Ouagadougou',
  },
  {
    id: 899,
    displayName: '(UTC+00:00) Africa/Sao_Tome',
    name: 'Africa/Sao_Tome',
  },
  {
    id: 944,
    displayName: '(UTC+00:00) America/Danmarkshavn',
    name: 'America/Danmarkshavn',
  },
  {
    id: 1145,
    displayName: '(UTC+00:00) Atlantic/Azores',
    name: 'Atlantic/Azores',
  },
  {
    id: 1151,
    displayName: '(UTC+00:00) Atlantic/Reykjavik',
    name: 'Atlantic/Reykjavik',
  },
  {
    id: 1153,
    displayName: '(UTC+00:00) Atlantic/St_Helena',
    name: 'Atlantic/St_Helena',
  },
  {
    id: 854,
    displayName: '(UTC+01:00) Africa/Algiers',
    name: 'Africa/Algiers',
  },
  {
    id: 857,
    displayName: '(UTC+01:00) Africa/Bangui',
    name: 'Africa/Bangui',
  },
  {
    id: 861,
    displayName: '(UTC+01:00) Africa/Brazzaville',
    name: 'Africa/Brazzaville',
  },
  {
    id: 864,
    displayName: '(UTC+01:00) Africa/Casablanca',
    name: 'Africa/Casablanca',
  },
  {
    id: 870,
    displayName: '(UTC+01:00) Africa/Douala',
    name: 'Africa/Douala',
  },
  {
    id: 871,
    displayName: '(UTC+01:00) Africa/El_Aaiun',
    name: 'Africa/El_Aaiun',
  },
  {
    id: 880,
    displayName: '(UTC+01:00) Africa/Kinshasa',
    name: 'Africa/Kinshasa',
  },
  {
    id: 881,
    displayName: '(UTC+01:00) Africa/Lagos',
    name: 'Africa/Lagos',
  },
  {
    id: 882,
    displayName: '(UTC+01:00) Africa/Libreville',
    name: 'Africa/Libreville',
  },
  {
    id: 884,
    displayName: '(UTC+01:00) Africa/Luanda',
    name: 'Africa/Luanda',
  },
  {
    id: 887,
    displayName: '(UTC+01:00) Africa/Malabo',
    name: 'Africa/Malabo',
  },
  {
    id: 894,
    displayName: '(UTC+01:00) Africa/Ndjamena',
    name: 'Africa/Ndjamena',
  },
  {
    id: 895,
    displayName: '(UTC+01:00) Africa/Niamey',
    name: 'Africa/Niamey',
  },
  {
    id: 898,
    displayName: '(UTC+01:00) Africa/Porto-Novo',
    name: 'Africa/Porto-Novo',
  },
  {
    id: 901,
    displayName: '(UTC+01:00) Africa/Tunis',
    name: 'Africa/Tunis',
  },
  {
    id: 1147,
    displayName: '(UTC+01:00) Atlantic/Canary',
    name: 'Atlantic/Canary',
  },
  {
    id: 1149,
    displayName: '(UTC+01:00) Atlantic/Faroe',
    name: 'Atlantic/Faroe',
  },
  {
    id: 1150,
    displayName: '(UTC+01:00) Atlantic/Madeira',
    name: 'Atlantic/Madeira',
  },
  {
    id: 1180,
    displayName: '(UTC+01:00) Europe/Dublin',
    name: 'Europe/Dublin',
  },
  {
    id: 1182,
    displayName: '(UTC+01:00) Europe/Guernsey',
    name: 'Europe/Guernsey',
  },
  {
    id: 1184,
    displayName: '(UTC+01:00) Europe/Isle_of_Man',
    name: 'Europe/Isle_of_Man',
  },
  {
    id: 1186,
    displayName: '(UTC+01:00) Europe/Jersey',
    name: 'Europe/Jersey',
  },
  {
    id: 1190,
    displayName: '(UTC+01:00) Europe/Lisbon',
    name: 'Europe/Lisbon',
  },
  {
    id: 1192,
    displayName: '(UTC+01:00) Europe/London',
    name: 'Europe/London',
  },
  {
    id: 860,
    displayName: '(UTC+02:00) Africa/Blantyre',
    name: 'Africa/Blantyre',
  },
  {
    id: 862,
    displayName: '(UTC+02:00) Africa/Bujumbura',
    name: 'Africa/Bujumbura',
  },
  {
    id: 865,
    displayName: '(UTC+02:00) Africa/Ceuta',
    name: 'Africa/Ceuta',
  },
  {
    id: 873,
    displayName: '(UTC+02:00) Africa/Gaborone',
    name: 'Africa/Gaborone',
  },
  {
    id: 874,
    displayName: '(UTC+02:00) Africa/Harare',
    name: 'Africa/Harare',
  },
  {
    id: 875,
    displayName: '(UTC+02:00) Africa/Johannesburg',
    name: 'Africa/Johannesburg',
  },
  {
    id: 876,
    displayName: '(UTC+02:00) Africa/Juba',
    name: 'Africa/Juba',
  },
  {
    id: 878,
    displayName: '(UTC+02:00) Africa/Khartoum',
    name: 'Africa/Khartoum',
  },
  {
    id: 879,
    displayName: '(UTC+02:00) Africa/Kigali',
    name: 'Africa/Kigali',
  },
  {
    id: 885,
    displayName: '(UTC+02:00) Africa/Lubumbashi',
    name: 'Africa/Lubumbashi',
  },
  {
    id: 886,
    displayName: '(UTC+02:00) Africa/Lusaka',
    name: 'Africa/Lusaka',
  },
  {
    id: 888,
    displayName: '(UTC+02:00) Africa/Maputo',
    name: 'Africa/Maputo',
  },
  {
    id: 889,
    displayName: '(UTC+02:00) Africa/Maseru',
    name: 'Africa/Maseru',
  },
  {
    id: 890,
    displayName: '(UTC+02:00) Africa/Mbabane',
    name: 'Africa/Mbabane',
  },
  {
    id: 900,
    displayName: '(UTC+02:00) Africa/Tripoli',
    name: 'Africa/Tripoli',
  },
  {
    id: 902,
    displayName: '(UTC+02:00) Africa/Windhoek',
    name: 'Africa/Windhoek',
  },
  {
    id: 1059,
    displayName: '(UTC+02:00) Antarctica/Troll',
    name: 'Antarctica/Troll',
  },
  {
    id: 1061,
    displayName: '(UTC+02:00) Arctic/Longyearbyen',
    name: 'Arctic/Longyearbyen',
  },
  {
    id: 1167,
    displayName: '(UTC+02:00) Europe/Amsterdam',
    name: 'Europe/Amsterdam',
  },
  {
    id: 1168,
    displayName: '(UTC+02:00) Europe/Andorra',
    name: 'Europe/Andorra',
  },
  {
    id: 1171,
    displayName: '(UTC+02:00) Europe/Belgrade',
    name: 'Europe/Belgrade',
  },
  {
    id: 1172,
    displayName: '(UTC+02:00) Europe/Berlin',
    name: 'Europe/Berlin',
  },
  {
    id: 1173,
    displayName: '(UTC+02:00) Europe/Bratislava',
    name: 'Europe/Bratislava',
  },
  {
    id: 1174,
    displayName: '(UTC+02:00) Europe/Brussels',
    name: 'Europe/Brussels',
  },
  {
    id: 1176,
    displayName: '(UTC+02:00) Europe/Budapest',
    name: 'Europe/Budapest',
  },
  {
    id: 1177,
    displayName: '(UTC+02:00) Europe/Busingen',
    name: 'Europe/Busingen',
  },
  {
    id: 1179,
    displayName: '(UTC+02:00) Europe/Copenhagen',
    name: 'Europe/Copenhagen',
  },
  {
    id: 1181,
    displayName: '(UTC+02:00) Europe/Gibraltar',
    name: 'Europe/Gibraltar',
  },
  {
    id: 1187,
    displayName: '(UTC+02:00) Europe/Kaliningrad',
    name: 'Europe/Kaliningrad',
  },
  {
    id: 1191,
    displayName: '(UTC+02:00) Europe/Ljubljana',
    name: 'Europe/Ljubljana',
  },
  {
    id: 1193,
    displayName: '(UTC+02:00) Europe/Luxembourg',
    name: 'Europe/Luxembourg',
  },
  {
    id: 1194,
    displayName: '(UTC+02:00) Europe/Madrid',
    name: 'Europe/Madrid',
  },
  {
    id: 1195,
    displayName: '(UTC+02:00) Europe/Malta',
    name: 'Europe/Malta',
  },
  {
    id: 1198,
    displayName: '(UTC+02:00) Europe/Monaco',
    name: 'Europe/Monaco',
  },
  {
    id: 1200,
    displayName: '(UTC+02:00) Europe/Oslo',
    name: 'Europe/Oslo',
  },
  {
    id: 1201,
    displayName: '(UTC+02:00) Europe/Paris',
    name: 'Europe/Paris',
  },
  {
    id: 1202,
    displayName: '(UTC+02:00) Europe/Podgorica',
    name: 'Europe/Podgorica',
  },
  {
    id: 1203,
    displayName: '(UTC+02:00) Europe/Prague',
    name: 'Europe/Prague',
  },
  {
    id: 1205,
    displayName: '(UTC+02:00) Europe/Rome',
    name: 'Europe/Rome',
  },
  {
    id: 1207,
    displayName: '(UTC+02:00) Europe/San_Marino',
    name: 'Europe/San_Marino',
  },
  {
    id: 1208,
    displayName: '(UTC+02:00) Europe/Sarajevo',
    name: 'Europe/Sarajevo',
  },
  {
    id: 1211,
    displayName: '(UTC+02:00) Europe/Skopje',
    name: 'Europe/Skopje',
  },
  {
    id: 1213,
    displayName: '(UTC+02:00) Europe/Stockholm',
    name: 'Europe/Stockholm',
  },
  {
    id: 1215,
    displayName: '(UTC+02:00) Europe/Tirane',
    name: 'Europe/Tirane',
  },
  {
    id: 1218,
    displayName: '(UTC+02:00) Europe/Vaduz',
    name: 'Europe/Vaduz',
  },
  {
    id: 1219,
    displayName: '(UTC+02:00) Europe/Vatican',
    name: 'Europe/Vatican',
  },
  {
    id: 1220,
    displayName: '(UTC+02:00) Europe/Vienna',
    name: 'Europe/Vienna',
  },
  {
    id: 1223,
    displayName: '(UTC+02:00) Europe/Warsaw',
    name: 'Europe/Warsaw',
  },
  {
    id: 1224,
    displayName: '(UTC+02:00) Europe/Zagreb',
    name: 'Europe/Zagreb',
  },
  {
    id: 1226,
    displayName: '(UTC+02:00) Europe/Zurich',
    name: 'Europe/Zurich',
  },
  {
    id: 853,
    displayName: '(UTC+03:00) Africa/Addis_Ababa',
    name: 'Africa/Addis_Ababa',
  },
  {
    id: 855,
    displayName: '(UTC+03:00) Africa/Asmara',
    name: 'Africa/Asmara',
  },
  {
    id: 863,
    displayName: '(UTC+03:00) Africa/Cairo',
    name: 'Africa/Cairo',
  },
  {
    id: 868,
    displayName: '(UTC+03:00) Africa/Dar_es_Salaam',
    name: 'Africa/Dar_es_Salaam',
  },
  {
    id: 869,
    displayName: '(UTC+03:00) Africa/Djibouti',
    name: 'Africa/Djibouti',
  },
  {
    id: 877,
    displayName: '(UTC+03:00) Africa/Kampala',
    name: 'Africa/Kampala',
  },
  {
    id: 891,
    displayName: '(UTC+03:00) Africa/Mogadishu',
    name: 'Africa/Mogadishu',
  },
  {
    id: 893,
    displayName: '(UTC+03:00) Africa/Nairobi',
    name: 'Africa/Nairobi',
  },
  {
    id: 1058,
    displayName: '(UTC+03:00) Antarctica/Syowa',
    name: 'Antarctica/Syowa',
  },
  {
    id: 1062,
    displayName: '(UTC+03:00) Asia/Aden',
    name: 'Asia/Aden',
  },
  {
    id: 1064,
    displayName: '(UTC+03:00) Asia/Amman',
    name: 'Asia/Amman',
  },
  {
    id: 1070,
    displayName: '(UTC+03:00) Asia/Baghdad',
    name: 'Asia/Baghdad',
  },
  {
    id: 1071,
    displayName: '(UTC+03:00) Asia/Bahrain',
    name: 'Asia/Bahrain',
  },
  {
    id: 1075,
    displayName: '(UTC+03:00) Asia/Beirut',
    name: 'Asia/Beirut',
  },
  {
    id: 1081,
    displayName: '(UTC+03:00) Asia/Damascus',
    name: 'Asia/Damascus',
  },
  {
    id: 1086,
    displayName: '(UTC+03:00) Asia/Famagusta',
    name: 'Asia/Famagusta',
  },
  {
    id: 1087,
    displayName: '(UTC+03:00) Asia/Gaza',
    name: 'Asia/Gaza',
  },
  {
    id: 1088,
    displayName: '(UTC+03:00) Asia/Hebron',
    name: 'Asia/Hebron',
  },
  {
    id: 1095,
    displayName: '(UTC+03:00) Asia/Jerusalem',
    name: 'Asia/Jerusalem',
  },
  {
    id: 1105,
    displayName: '(UTC+03:00) Asia/Kuwait',
    name: 'Asia/Kuwait',
  },
  {
    id: 1111,
    displayName: '(UTC+03:00) Asia/Nicosia',
    name: 'Asia/Nicosia',
  },
  {
    id: 1119,
    displayName: '(UTC+03:00) Asia/Qatar',
    name: 'Asia/Qatar',
  },
  {
    id: 1122,
    displayName: '(UTC+03:00) Asia/Riyadh',
    name: 'Asia/Riyadh',
  },
  {
    id: 1170,
    displayName: '(UTC+03:00) Europe/Athens',
    name: 'Europe/Athens',
  },
  {
    id: 1175,
    displayName: '(UTC+03:00) Europe/Bucharest',
    name: 'Europe/Bucharest',
  },
  {
    id: 1178,
    displayName: '(UTC+03:00) Europe/Chisinau',
    name: 'Europe/Chisinau',
  },
  {
    id: 1183,
    displayName: '(UTC+03:00) Europe/Helsinki',
    name: 'Europe/Helsinki',
  },
  {
    id: 1185,
    displayName: '(UTC+03:00) Europe/Istanbul',
    name: 'Europe/Istanbul',
  },
  {
    id: 1188,
    displayName: '(UTC+03:00) Europe/Kiev',
    name: 'Europe/Kiev',
  },
  {
    id: 1189,
    displayName: '(UTC+03:00) Europe/Kirov',
    name: 'Europe/Kirov',
  },
  {
    id: 1281,
    displayName: '(UTC+03:00) Europe/Kyiv',
    name: 'Europe/Kyiv',
  },
  {
    id: 1196,
    displayName: '(UTC+03:00) Europe/Mariehamn',
    name: 'Europe/Mariehamn',
  },
  {
    id: 1197,
    displayName: '(UTC+03:00) Europe/Minsk',
    name: 'Europe/Minsk',
  },
  {
    id: 1199,
    displayName: '(UTC+03:00) Europe/Moscow',
    name: 'Europe/Moscow',
  },
  {
    id: 1204,
    displayName: '(UTC+03:00) Europe/Riga',
    name: 'Europe/Riga',
  },
  {
    id: 1210,
    displayName: '(UTC+03:00) Europe/Simferopol',
    name: 'Europe/Simferopol',
  },
  {
    id: 1212,
    displayName: '(UTC+03:00) Europe/Sofia',
    name: 'Europe/Sofia',
  },
  {
    id: 1214,
    displayName: '(UTC+03:00) Europe/Tallinn',
    name: 'Europe/Tallinn',
  },
  {
    id: 1217,
    displayName: '(UTC+03:00) Europe/Uzhgorod',
    name: 'Europe/Uzhgorod',
  },
  {
    id: 1221,
    displayName: '(UTC+03:00) Europe/Vilnius',
    name: 'Europe/Vilnius',
  },
  {
    id: 1222,
    displayName: '(UTC+03:00) Europe/Volgograd',
    name: 'Europe/Volgograd',
  },
  {
    id: 1225,
    displayName: '(UTC+03:00) Europe/Zaporozhye',
    name: 'Europe/Zaporozhye',
  },
  {
    id: 1227,
    displayName: '(UTC+03:00) Indian/Antananarivo',
    name: 'Indian/Antananarivo',
  },
  {
    id: 1231,
    displayName: '(UTC+03:00) Indian/Comoro',
    name: 'Indian/Comoro',
  },
  {
    id: 1236,
    displayName: '(UTC+03:00) Indian/Mayotte',
    name: 'Indian/Mayotte',
  },
  {
    id: 1132,
    displayName: '(UTC+03:30) Asia/Tehran',
    name: 'Asia/Tehran',
  },
  {
    id: 1072,
    displayName: '(UTC+04:00) Asia/Baku',
    name: 'Asia/Baku',
  },
  {
    id: 1084,
    displayName: '(UTC+04:00) Asia/Dubai',
    name: 'Asia/Dubai',
  },
  {
    id: 1110,
    displayName: '(UTC+04:00) Asia/Muscat',
    name: 'Asia/Muscat',
  },
  {
    id: 1131,
    displayName: '(UTC+04:00) Asia/Tbilisi',
    name: 'Asia/Tbilisi',
  },
  {
    id: 1144,
    displayName: '(UTC+04:00) Asia/Yerevan',
    name: 'Asia/Yerevan',
  },
  {
    id: 1169,
    displayName: '(UTC+04:00) Europe/Astrakhan',
    name: 'Europe/Astrakhan',
  },
  {
    id: 1206,
    displayName: '(UTC+04:00) Europe/Samara',
    name: 'Europe/Samara',
  },
  {
    id: 1209,
    displayName: '(UTC+04:00) Europe/Saratov',
    name: 'Europe/Saratov',
  },
  {
    id: 1216,
    displayName: '(UTC+04:00) Europe/Ulyanovsk',
    name: 'Europe/Ulyanovsk',
  },
  {
    id: 1233,
    displayName: '(UTC+04:00) Indian/Mahe',
    name: 'Indian/Mahe',
  },
  {
    id: 1235,
    displayName: '(UTC+04:00) Indian/Mauritius',
    name: 'Indian/Mauritius',
  },
  {
    id: 1237,
    displayName: '(UTC+04:00) Indian/Reunion',
    name: 'Indian/Reunion',
  },
  {
    id: 1096,
    displayName: '(UTC+04:30) Asia/Kabul',
    name: 'Asia/Kabul',
  },
  {
    id: 1054,
    displayName: '(UTC+05:00) Antarctica/Mawson',
    name: 'Antarctica/Mawson',
  },
  {
    id: 1060,
    displayName: '(UTC+05:00) Antarctica/Vostok',
    name: 'Antarctica/Vostok',
  },
  {
    id: 1066,
    displayName: '(UTC+05:00) Asia/Aqtau',
    name: 'Asia/Aqtau',
  },
  {
    id: 1067,
    displayName: '(UTC+05:00) Asia/Aqtobe',
    name: 'Asia/Aqtobe',
  },
  {
    id: 1068,
    displayName: '(UTC+05:00) Asia/Ashgabat',
    name: 'Asia/Ashgabat',
  },
  {
    id: 1069,
    displayName: '(UTC+05:00) Asia/Atyrau',
    name: 'Asia/Atyrau',
  },
  {
    id: 1085,
    displayName: '(UTC+05:00) Asia/Dushanbe',
    name: 'Asia/Dushanbe',
  },
  {
    id: 1098,
    displayName: '(UTC+05:00) Asia/Karachi',
    name: 'Asia/Karachi',
  },
  {
    id: 1115,
    displayName: '(UTC+05:00) Asia/Oral',
    name: 'Asia/Oral',
  },
  {
    id: 1121,
    displayName: '(UTC+05:00) Asia/Qyzylorda',
    name: 'Asia/Qyzylorda',
  },
  {
    id: 1124,
    displayName: '(UTC+05:00) Asia/Samarkand',
    name: 'Asia/Samarkand',
  },
  {
    id: 1130,
    displayName: '(UTC+05:00) Asia/Tashkent',
    name: 'Asia/Tashkent',
  },
  {
    id: 1143,
    displayName: '(UTC+05:00) Asia/Yekaterinburg',
    name: 'Asia/Yekaterinburg',
  },
  {
    id: 1232,
    displayName: '(UTC+05:00) Indian/Kerguelen',
    name: 'Indian/Kerguelen',
  },
  {
    id: 1234,
    displayName: '(UTC+05:00) Indian/Maldives',
    name: 'Indian/Maldives',
  },
  {
    id: 1080,
    displayName: '(UTC+05:30) Asia/Colombo',
    name: 'Asia/Colombo',
  },
  {
    id: 1101,
    displayName: '(UTC+05:30) Asia/Kolkata',
    name: 'Asia/Kolkata',
  },
  {
    id: 1099,
    displayName: '(UTC+05:45) Asia/Kathmandu',
    name: 'Asia/Kathmandu',
  },
  {
    id: 1063,
    displayName: '(UTC+06:00) Asia/Almaty',
    name: 'Asia/Almaty',
  },
  {
    id: 1076,
    displayName: '(UTC+06:00) Asia/Bishkek',
    name: 'Asia/Bishkek',
  },
  {
    id: 1082,
    displayName: '(UTC+06:00) Asia/Dhaka',
    name: 'Asia/Dhaka',
  },
  {
    id: 1114,
    displayName: '(UTC+06:00) Asia/Omsk',
    name: 'Asia/Omsk',
  },
  {
    id: 1120,
    displayName: '(UTC+06:00) Asia/Qostanay',
    name: 'Asia/Qostanay',
  },
  {
    id: 1133,
    displayName: '(UTC+06:00) Asia/Thimphu',
    name: 'Asia/Thimphu',
  },
  {
    id: 1137,
    displayName: '(UTC+06:00) Asia/Urumqi',
    name: 'Asia/Urumqi',
  },
  {
    id: 1228,
    displayName: '(UTC+06:00) Indian/Chagos',
    name: 'Indian/Chagos',
  },
  {
    id: 1142,
    displayName: '(UTC+06:30) Asia/Yangon',
    name: 'Asia/Yangon',
  },
  {
    id: 1230,
    displayName: '(UTC+06:30) Indian/Cocos',
    name: 'Indian/Cocos',
  },
  {
    id: 1051,
    displayName: '(UTC+07:00) Antarctica/Davis',
    name: 'Antarctica/Davis',
  },
  {
    id: 1073,
    displayName: '(UTC+07:00) Asia/Bangkok',
    name: 'Asia/Bangkok',
  },
  {
    id: 1074,
    displayName: '(UTC+07:00) Asia/Barnaul',
    name: 'Asia/Barnaul',
  },
  {
    id: 1089,
    displayName: '(UTC+07:00) Asia/Ho_Chi_Minh',
    name: 'Asia/Ho_Chi_Minh',
  },
  {
    id: 1091,
    displayName: '(UTC+07:00) Asia/Hovd',
    name: 'Asia/Hovd',
  },
  {
    id: 1093,
    displayName: '(UTC+07:00) Asia/Jakarta',
    name: 'Asia/Jakarta',
  },
  {
    id: 1102,
    displayName: '(UTC+07:00) Asia/Krasnoyarsk',
    name: 'Asia/Krasnoyarsk',
  },
  {
    id: 1112,
    displayName: '(UTC+07:00) Asia/Novokuznetsk',
    name: 'Asia/Novokuznetsk',
  },
  {
    id: 1113,
    displayName: '(UTC+07:00) Asia/Novosibirsk',
    name: 'Asia/Novosibirsk',
  },
  {
    id: 1116,
    displayName: '(UTC+07:00) Asia/Phnom_Penh',
    name: 'Asia/Phnom_Penh',
  },
  {
    id: 1117,
    displayName: '(UTC+07:00) Asia/Pontianak',
    name: 'Asia/Pontianak',
  },
  {
    id: 1135,
    displayName: '(UTC+07:00) Asia/Tomsk',
    name: 'Asia/Tomsk',
  },
  {
    id: 1139,
    displayName: '(UTC+07:00) Asia/Vientiane',
    name: 'Asia/Vientiane',
  },
  {
    id: 1229,
    displayName: '(UTC+07:00) Indian/Christmas',
    name: 'Indian/Christmas',
  },
  {
    id: 1050,
    displayName: '(UTC+08:00) Antarctica/Casey',
    name: 'Antarctica/Casey',
  },
  {
    id: 1077,
    displayName: '(UTC+08:00) Asia/Brunei',
    name: 'Asia/Brunei',
  },
  {
    id: 1079,
    displayName: '(UTC+08:00) Asia/Choibalsan',
    name: 'Asia/Choibalsan',
  },
  {
    id: 1090,
    displayName: '(UTC+08:00) Asia/Hong_Kong',
    name: 'Asia/Hong_Kong',
  },
  {
    id: 1092,
    displayName: '(UTC+08:00) Asia/Irkutsk',
    name: 'Asia/Irkutsk',
  },
  {
    id: 1103,
    displayName: '(UTC+08:00) Asia/Kuala_Lumpur',
    name: 'Asia/Kuala_Lumpur',
  },
  {
    id: 1104,
    displayName: '(UTC+08:00) Asia/Kuching',
    name: 'Asia/Kuching',
  },
  {
    id: 1106,
    displayName: '(UTC+08:00) Asia/Macau',
    name: 'Asia/Macau',
  },
  {
    id: 1108,
    displayName: '(UTC+08:00) Asia/Makassar',
    name: 'Asia/Makassar',
  },
  {
    id: 1109,
    displayName: '(UTC+08:00) Asia/Manila',
    name: 'Asia/Manila',
  },
  {
    id: 1126,
    displayName: '(UTC+08:00) Asia/Shanghai',
    name: 'Asia/Shanghai',
  },
  {
    id: 1127,
    displayName: '(UTC+08:00) Asia/Singapore',
    name: 'Asia/Singapore',
  },
  {
    id: 1129,
    displayName: '(UTC+08:00) Asia/Taipei',
    name: 'Asia/Taipei',
  },
  {
    id: 1136,
    displayName: '(UTC+08:00) Asia/Ulaanbaatar',
    name: 'Asia/Ulaanbaatar',
  },
  {
    id: 1165,
    displayName: '(UTC+08:00) Australia/Perth',
    name: 'Australia/Perth',
  },
  {
    id: 1160,
    displayName: '(UTC+08:45) Australia/Eucla',
    name: 'Australia/Eucla',
  },
  {
    id: 1078,
    displayName: '(UTC+09:00) Asia/Chita',
    name: 'Asia/Chita',
  },
  {
    id: 1083,
    displayName: '(UTC+09:00) Asia/Dili',
    name: 'Asia/Dili',
  },
  {
    id: 1094,
    displayName: '(UTC+09:00) Asia/Jayapura',
    name: 'Asia/Jayapura',
  },
  {
    id: 1100,
    displayName: '(UTC+09:00) Asia/Khandyga',
    name: 'Asia/Khandyga',
  },
  {
    id: 1118,
    displayName: '(UTC+09:00) Asia/Pyongyang',
    name: 'Asia/Pyongyang',
  },
  {
    id: 1125,
    displayName: '(UTC+09:00) Asia/Seoul',
    name: 'Asia/Seoul',
  },
  {
    id: 1134,
    displayName: '(UTC+09:00) Asia/Tokyo',
    name: 'Asia/Tokyo',
  },
  {
    id: 1141,
    displayName: '(UTC+09:00) Asia/Yakutsk',
    name: 'Asia/Yakutsk',
  },
  {
    id: 1265,
    displayName: '(UTC+09:00) Pacific/Palau',
    name: 'Pacific/Palau',
  },
  {
    id: 1155,
    displayName: '(UTC+09:30) Australia/Adelaide',
    name: 'Australia/Adelaide',
  },
  {
    id: 1157,
    displayName: '(UTC+09:30) Australia/Broken_Hill',
    name: 'Australia/Broken_Hill',
  },
  {
    id: 1159,
    displayName: '(UTC+09:30) Australia/Darwin',
    name: 'Australia/Darwin',
  },
  {
    id: 1052,
    displayName: '(UTC+10:00) Antarctica/DumontDUrville',
    name: 'Antarctica/DumontDUrville',
  },
  {
    id: 1053,
    displayName: '(UTC+10:00) Antarctica/Macquarie',
    name: 'Antarctica/Macquarie',
  },
  {
    id: 1138,
    displayName: '(UTC+10:00) Asia/Ust-Nera',
    name: 'Asia/Ust-Nera',
  },
  {
    id: 1140,
    displayName: '(UTC+10:00) Asia/Vladivostok',
    name: 'Asia/Vladivostok',
  },
  {
    id: 1156,
    displayName: '(UTC+10:00) Australia/Brisbane',
    name: 'Australia/Brisbane',
  },
  {
    id: 1158,
    displayName: '(UTC+10:00) Australia/Currie',
    name: 'Australia/Currie',
  },
  {
    id: 1161,
    displayName: '(UTC+10:00) Australia/Hobart',
    name: 'Australia/Hobart',
  },
  {
    id: 1162,
    displayName: '(UTC+10:00) Australia/Lindeman',
    name: 'Australia/Lindeman',
  },
  {
    id: 1164,
    displayName: '(UTC+10:00) Australia/Melbourne',
    name: 'Australia/Melbourne',
  },
  {
    id: 1166,
    displayName: '(UTC+10:00) Australia/Sydney',
    name: 'Australia/Sydney',
  },
  {
    id: 1242,
    displayName: '(UTC+10:00) Pacific/Chuuk',
    name: 'Pacific/Chuuk',
  },
  {
    id: 1252,
    displayName: '(UTC+10:00) Pacific/Guam',
    name: 'Pacific/Guam',
  },
  {
    id: 1268,
    displayName: '(UTC+10:00) Pacific/Port_Moresby',
    name: 'Pacific/Port_Moresby',
  },
  {
    id: 1270,
    displayName: '(UTC+10:00) Pacific/Saipan',
    name: 'Pacific/Saipan',
  },
  {
    id: 1163,
    displayName: '(UTC+10:30) Australia/Lord_Howe',
    name: 'Australia/Lord_Howe',
  },
  {
    id: 1107,
    displayName: '(UTC+11:00) Asia/Magadan',
    name: 'Asia/Magadan',
  },
  {
    id: 1123,
    displayName: '(UTC+11:00) Asia/Sakhalin',
    name: 'Asia/Sakhalin',
  },
  {
    id: 1128,
    displayName: '(UTC+11:00) Asia/Srednekolymsk',
    name: 'Asia/Srednekolymsk',
  },
  {
    id: 1240,
    displayName: '(UTC+11:00) Pacific/Bougainville',
    name: 'Pacific/Bougainville',
  },
  {
    id: 1244,
    displayName: '(UTC+11:00) Pacific/Efate',
    name: 'Pacific/Efate',
  },
  {
    id: 1251,
    displayName: '(UTC+11:00) Pacific/Guadalcanal',
    name: 'Pacific/Guadalcanal',
  },
  {
    id: 1255,
    displayName: '(UTC+11:00) Pacific/Kosrae',
    name: 'Pacific/Kosrae',
  },
  {
    id: 1262,
    displayName: '(UTC+11:00) Pacific/Norfolk',
    name: 'Pacific/Norfolk',
  },
  {
    id: 1263,
    displayName: '(UTC+11:00) Pacific/Noumea',
    name: 'Pacific/Noumea',
  },
  {
    id: 1267,
    displayName: '(UTC+11:00) Pacific/Pohnpei',
    name: 'Pacific/Pohnpei',
  },
  {
    id: 1055,
    displayName: '(UTC+12:00) Antarctica/McMurdo',
    name: 'Antarctica/McMurdo',
  },
  {
    id: 1065,
    displayName: '(UTC+12:00) Asia/Anadyr',
    name: 'Asia/Anadyr',
  },
  {
    id: 1097,
    displayName: '(UTC+12:00) Asia/Kamchatka',
    name: 'Asia/Kamchatka',
  },
  {
    id: 1239,
    displayName: '(UTC+12:00) Pacific/Auckland',
    name: 'Pacific/Auckland',
  },
  {
    id: 1247,
    displayName: '(UTC+12:00) Pacific/Fiji',
    name: 'Pacific/Fiji',
  },
  {
    id: 1248,
    displayName: '(UTC+12:00) Pacific/Funafuti',
    name: 'Pacific/Funafuti',
  },
  {
    id: 1256,
    displayName: '(UTC+12:00) Pacific/Kwajalein',
    name: 'Pacific/Kwajalein',
  },
  {
    id: 1257,
    displayName: '(UTC+12:00) Pacific/Majuro',
    name: 'Pacific/Majuro',
  },
  {
    id: 1260,
    displayName: '(UTC+12:00) Pacific/Nauru',
    name: 'Pacific/Nauru',
  },
  {
    id: 1272,
    displayName: '(UTC+12:00) Pacific/Tarawa',
    name: 'Pacific/Tarawa',
  },
  {
    id: 1274,
    displayName: '(UTC+12:00) Pacific/Wake',
    name: 'Pacific/Wake',
  },
  {
    id: 1275,
    displayName: '(UTC+12:00) Pacific/Wallis',
    name: 'Pacific/Wallis',
  },
  {
    id: 1241,
    displayName: '(UTC+12:45) Pacific/Chatham',
    name: 'Pacific/Chatham',
  },
  {
    id: 1238,
    displayName: '(UTC+13:00) Pacific/Apia',
    name: 'Pacific/Apia',
  },
  {
    id: 1245,
    displayName: '(UTC+13:00) Pacific/Enderbury',
    name: 'Pacific/Enderbury',
  },
  {
    id: 1246,
    displayName: '(UTC+13:00) Pacific/Fakaofo',
    name: 'Pacific/Fakaofo',
  },
  {
    id: 1280,
    displayName: '(UTC+13:00) Pacific/Kanton',
    name: 'Pacific/Kanton',
  },
  {
    id: 1273,
    displayName: '(UTC+13:00) Pacific/Tongatapu',
    name: 'Pacific/Tongatapu',
  },
  {
    id: 1254,
    displayName: '(UTC+14:00) Pacific/Kiritimati',
    name: 'Pacific/Kiritimati',
  },
]

export const FALLBACK_PERMISSIONS = [
  {
    name: 'device.sensors_list',
    displayName: 'Device sensor list',
  },
  {
    name: 'device.sensors_list.edit',
    displayName: 'Device sensor edit',
  },
  {
    name: 'fleet.vehicle_list.archive',
    displayName: 'Archive vehicle',
  },
  {
    name: 'device.sensors_list.add',
    displayName: 'Device sensor create',
  },
  {
    name: 'device.sensors_list.delete',
    displayName: 'Device sensor delete',
  },
  {
    name: 'move_device',
    displayName: 'Move device',
  },
  {
    name: 'fleet.vehicle_list.add',
    displayName: 'Fleet section add vehicles',
  },
  {
    name: 'configuration.users_list.archive',
    displayName: 'Client archive user',
  },
  {
    name: 'client_list',
    displayName: 'Client List',
  },
  {
    name: 'new_client',
    displayName: 'New Client',
  },
  {
    name: 'configuration.users_list.add',
    displayName: 'Client New User',
  },
  {
    name: 'configuration.users_list.edit',
    displayName: 'Client Edit User',
  },
  {
    name: 'configuration.users_list.delete',
    displayName: 'Client Delete User',
  },
  {
    name: 'configuration.company_info.status_history',
    displayName: 'Client Status History',
  },
  {
    name: 'client_updated_history',
    displayName: 'Client Updated History',
  },
  {
    name: 'configuration.company_info.notes_history',
    displayName: 'Client notes history',
  },
  {
    name: 'client_created_history',
    displayName: 'Client Created History',
  },
  {
    name: 'admin_team_user_list',
    displayName: 'Admin Team User List',
  },
  {
    name: 'user_history_created',
    displayName: 'User Created History',
  },
  {
    name: 'user_history_updated',
    displayName: 'User Updated History',
  },
  {
    name: 'user_history_last_login',
    displayName: 'User Last Login History',
  },
  {
    name: 'device_new',
    displayName: 'Client new device',
  },
  {
    name: 'device.devices_list',
    displayName: 'Client devices',
  },
  {
    name: 'device.devices_list.edit',
    displayName: 'Client edit device',
  },
  {
    name: 'device_delete',
    displayName: 'Client delete device',
  },
  {
    name: 'admin_team_edit_user',
    displayName: 'Admin Team Edit User',
  },
  {
    name: 'admin_team_new_user',
    displayName: 'Admin Team New User',
  },
  {
    name: 'device.devices_list.install',
    displayName: 'Delete install/uninstall',
  },
  {
    name: 'device_change_team',
    displayName: 'Device change team',
  },
  {
    name: 'fleet.vehicle_list.edit',
    displayName: 'Edit vehicle',
  },
  {
    name: 'fleet.vehicle_list.delete',
    displayName: 'Delete vehicle',
  },
  {
    name: 'configuration.fleet.vehicle_groups_list',
    displayName: 'Vehicle group list',
  },
  {
    name: 'setting_set',
    displayName: 'Set settings',
  },
  {
    name: 'configuration.fleet.depot_list',
    displayName: 'Depots',
  },
  {
    name: 'fleet.service_reminders_list',
    displayName: 'reminders',
  },
  {
    name: 'fleet.service_reminders_list.service_record_list',
    displayName: 'service records',
  },
  {
    name: 'fleet.documents_list',
    displayName: 'Documents list',
  },
  {
    name: 'configuration.areas.areas_list',
    displayName: 'Areas list',
  },
  {
    name: 'configuration.areas.areas_groups_list',
    displayName: 'Area group list',
  },
  {
    name: 'login_as_client',
    displayName: 'Login as client',
  },
  {
    name: 'login_as_user',
    displayName: 'Login as user',
  },
  {
    name: 'full_search',
    displayName: 'Full search',
  },
  {
    name: 'drivers.drivers_list',
    displayName: 'Driver list',
  },
  {
    name: 'fuel_ignore_new',
    displayName: 'New fuel ignore',
  },
  {
    name: 'fuel_ignore_edit',
    displayName: 'Edit fuel ignore',
  },
  {
    name: 'fuel_ignore_list',
    displayName: 'Fuel ignore list',
  },
  {
    name: 'fuel_ignore_delete',
    displayName: 'Delete fuel ignore',
  },
  {
    name: 'fuel_mapping_new',
    displayName: 'New fuel mapping',
  },
  {
    name: 'fuel_mapping_edit',
    displayName: 'Edit fuel mapping',
  },
  {
    name: 'fuel_mapping_list',
    displayName: 'Fuel mapping list',
  },
  {
    name: 'fuel_mapping_delete',
    displayName: 'Delete fuel mapping',
  },
  {
    name: 'map_view',
    displayName: 'Map view',
  },
  {
    name: 'reminder_category_list',
    displayName: 'Reminder Category list',
  },
  {
    name: 'reminder_category_new',
    displayName: 'New Reminder Category',
  },
  {
    name: 'reminder_category_edit',
    displayName: 'Edit Reminder Category',
  },
  {
    name: 'reminder_category_delete',
    displayName: 'Delete Reminder Category',
  },
  {
    name: 'billing_plan.edit',
    displayName: 'Edit Billing Plan',
  },
  {
    name: 'inspection_form_fill',
    displayName: 'Fill Inspection form',
  },
  {
    name: 'inspection_form_filled',
    displayName: 'Get filled inspection form',
  },
  {
    name: 'fleet.repair_costs_list',
    displayName: 'Repair cost list',
  },
  {
    name: 'configuration.notifications_list.add',
    displayName: 'New notification',
  },
  {
    name: 'configuration.notifications_list',
    displayName: 'Notifications',
  },
  {
    name: 'configuration.notifications_list.edit',
    displayName: 'Edit notification',
  },
  {
    name: 'configuration.notifications_list.delete',
    displayName: 'Delete notification',
  },
  {
    name: 'client_section',
    displayName: 'Client section',
  },
  {
    name: 'alerts',
    displayName: 'Alerts section',
  },
  {
    name: 'configuration',
    displayName: 'Configuration section',
  },
  {
    name: 'admin_team_section',
    displayName: 'Admin team section',
  },
  {
    name: 'support',
    displayName: 'Support section',
  },
  {
    name: 'xero_api',
    displayName: 'Xero API',
  },
  {
    name: 'stripe_api',
    displayName: 'Stripe API',
  },
  {
    name: 'billing.invoice_view',
    displayName: 'View invoice',
  },
  {
    name: 'billing_admin',
    displayName: 'Billing admin',
  },
  {
    name: 'devices_vehicles_import_data',
    displayName: 'Import devices/vehicles data',
  },
  {
    name: 'fuel_types_list',
    displayName: 'Fuel types list',
  },
  {
    name: 'set_mobile_device_token',
    displayName: 'Set mobile device token',
  },
  {
    name: 'configuration.driving_options',
    displayName: 'Configuration driving options',
  },
  {
    name: 'inspection_form_set_team',
    displayName: 'Inspection form set team',
  },
  {
    name: 'fleet.vehicle_list',
    displayName: 'Fleet section fleet',
  },
  {
    name: 'digital_form_list',
    displayName: 'Digital form list',
  },
  {
    name: 'digital_form_view',
    displayName: 'Digital form view',
  },
  {
    name: 'digital_form_answer_view',
    displayName: 'Digital form answer view',
  },
  {
    name: 'digital_form_answer_create',
    displayName: 'Digital form answer create',
  },
  {
    name: 'configuration.scheduled_report_list',
    displayName: 'Scheduled report list',
  },
  {
    name: 'configuration.scheduled_report_list.add',
    displayName: 'Scheduled report create',
  },
  {
    name: 'configuration.scheduled_report_list.edit',
    displayName: 'Scheduled report edit',
  },
  {
    name: 'configuration.scheduled_report_list.delete',
    displayName: 'Scheduled report delete',
  },
  {
    name: 'reseller_new',
    displayName: 'Reseller create',
  },
  {
    name: 'reseller_edit',
    displayName: 'Reseller edit',
  },
  {
    name: 'reseller_delete',
    displayName: 'Reseller delete',
  },
  {
    name: 'reseller_list',
    displayName: 'Reseller list',
  },
  {
    name: 'reseller_user_new',
    displayName: 'Reseller user create',
  },
  {
    name: 'reseller_user_edit',
    displayName: 'Reseller user edit',
  },
  {
    name: 'reseller_user_delete',
    displayName: 'Reseller user delete',
  },
  {
    name: 'reseller_user_list',
    displayName: 'Reseller user list',
  },
  {
    name: 'reseller_section',
    displayName: 'Reseller section',
  },
  {
    name: 'login_as_reseller',
    displayName: 'Login as reseller',
  },
  {
    name: 'reseller_notes_history',
    displayName: 'Reseller notes history',
  },
  {
    name: 'platform_setting_reseller_edit',
    displayName: 'Reseller Platform setting edit',
  },
  {
    name: 'configuration.users_list.block_user',
    displayName: 'Block client user',
  },
  {
    name: 'configuration.users_list.reset_password',
    displayName: 'Reset client user password',
  },
  {
    name: 'configuration.notifications_list',
    displayName: 'Configuration notifications',
  },
  {
    name: 'device',
    displayName: 'Device',
  },
  {
    name: 'configuration.company_info',
    displayName: 'Configuration company info',
  },
  {
    name: 'configuration.company_info.edit',
    displayName: 'Edit company info',
  },
  {
    name: 'support.submit_ticket',
    displayName: 'Submit support ticket',
  },
  {
    name: 'support.contact_us',
    displayName: 'Support contact us',
  },
  {
    name: 'configuration.users_list',
    displayName: 'Configuration users',
  },
  {
    name: 'vehicle_new',
    displayName: 'vehicle_new',
  },
  {
    name: 'device_by_id',
    displayName: 'device_by_id',
  },
  {
    name: 'vehicle_group_list',
    displayName: 'vehicle_group_list',
  },
  {
    name: 'depot_list',
    displayName: 'depot_list',
  },
  {
    name: 'fleet_section_service_reminders',
    displayName: 'fleet_section_service_reminders',
  },
  {
    name: 'fleet_section_documents',
    displayName: 'fleet_section_documents',
  },
  {
    name: 'repair_cost_list',
    displayName: 'repair_cost_list',
  },
  {
    name: 'AdminNotesHistory',
    displayName: 'Adminnoteshistory',
  },
  {
    name: 'alerts_section',
    displayName: 'Alerts Section',
  },
  {
    name: 'area_delete',
    displayName: 'Area Delete',
  },
  {
    name: 'area_edit',
    displayName: 'Area Edit',
  },
  {
    name: 'area_group_delete',
    displayName: 'Area Group Delete',
  },
  {
    name: 'area_group_edit',
    displayName: 'Area Group Edit',
  },
  {
    name: 'area_group_list',
    displayName: 'Area Group List',
  },
  {
    name: 'area_group_new',
    displayName: 'Area Group New',
  },
  {
    name: 'area_list',
    displayName: 'Area List',
  },
  {
    name: 'area_new',
    displayName: 'Area New',
  },
  {
    name: 'asset',
    displayName: 'Asset',
  },
  {
    name: 'asset.assets_list',
    displayName: 'Asset Assets List',
  },
  {
    name: 'asset.assets_list.add',
    displayName: 'Asset Assets List Add',
  },
  {
    name: 'asset.assets_list.delete',
    displayName: 'Asset Assets List Delete',
  },
  {
    name: 'asset.assets_list.edit',
    displayName: 'Asset Assets List Edit',
  },
  {
    name: 'asset.assets_list.install_uninstall',
    displayName: 'Asset Assets List Install Uninstall',
  },
  {
    name: 'asset.documents_list',
    displayName: 'Asset Documents List',
  },
  {
    name: 'asset.documents_list.add',
    displayName: 'Asset Documents List Add',
  },
  {
    name: 'asset.documents_list.archive',
    displayName: 'Asset Documents List Archive',
  },
  {
    name: 'asset.documents_list.delete',
    displayName: 'Asset Documents List Delete',
  },
  {
    name: 'asset.documents_list.edit',
    displayName: 'Asset Documents List Edit',
  },
  {
    name: 'asset.documents_list.records_list',
    displayName: 'Asset Documents List Records List',
  },
  {
    name: 'asset.documents_list.records_list.add',
    displayName: 'Asset Documents List Records List Add',
  },
  {
    name: 'asset.service_reminders_list',
    displayName: 'Asset Service Reminders List',
  },
  {
    name: 'asset.service_reminders_list.add',
    displayName: 'Asset Service Reminders List Add',
  },
  {
    name: 'asset.service_reminders_list.archive',
    displayName: 'Asset Service Reminders List Archive',
  },
  {
    name: 'asset.service_reminders_list.delete',
    displayName: 'Asset Service Reminders List Delete',
  },
  {
    name: 'asset.service_reminders_list.edit',
    displayName: 'Asset Service Reminders List Edit',
  },
  {
    name: 'asset.service_reminders_list.records_list',
    displayName: 'Asset Service Reminders List Records List',
  },
  {
    name: 'asset.service_reminders_list.records_list.add',
    displayName: 'Asset Service Reminders List Records List Add',
  },
  {
    name: 'asset.service_reminders_list.records_list.delete',
    displayName: 'Asset Service Reminders List Records List Delete',
  },
  {
    name: 'asset.service_reminders_list.records_list.edit',
    displayName: 'Asset Service Reminders List Records List Edit',
  },
  {
    name: 'asset_delete',
    displayName: 'Asset Delete',
  },
  {
    name: 'asset_documents',
    displayName: 'Asset Documents',
  },
  {
    name: 'asset_edit',
    displayName: 'Asset Edit',
  },
  {
    name: 'asset_install_uninstall',
    displayName: 'Asset Install Uninstall',
  },
  {
    name: 'asset_list',
    displayName: 'Asset List',
  },
  {
    name: 'asset_new',
    displayName: 'Asset New',
  },
  {
    name: 'asset_section',
    displayName: 'Asset Section',
  },
  {
    name: 'asset_section_documents',
    displayName: 'Asset Section Documents',
  },
  {
    name: 'asset_section_edit_documents',
    displayName: 'Asset Section Edit Documents',
  },
  {
    name: 'asset_section_edit_repair_costs',
    displayName: 'Asset Section Edit Repair Costs',
  },
  {
    name: 'asset_section_edit_service_reminder',
    displayName: 'Asset Section Edit Service Reminder',
  },
  {
    name: 'asset_section_service_reminders',
    displayName: 'Asset Section Service Reminders',
  },
  {
    name: 'asset_service_reminders',
    displayName: 'Asset Service Reminders',
  },
  {
    name: 'billing',
    displayName: 'Billing',
  },
  {
    name: 'billing.clean',
    displayName: 'Billing Clean',
  },
  {
    name: 'billing.invoice_pay',
    displayName: 'Billing Invoice Pay',
  },
  {
    name: 'billing.payment_change',
    displayName: 'Billing Payment Change',
  },
  {
    name: 'cameras',
    displayName: 'Cameras',
  },
  {
    name: 'cameras.cameras_module',
    displayName: 'Cameras Cameras Module',
  },
  {
    name: 'cameras.cameras_module.archive',
    displayName: 'Cameras Cameras Module Archive',
  },
  {
    name: 'cameras.cameras_module.configuration',
    displayName: 'Cameras Cameras Module Configuration',
  },
  {
    name: 'cameras.cameras_module.events',
    displayName: 'Cameras Cameras Module Events',
  },
  {
    name: 'cameras.channels',
    displayName: 'Cameras Channels',
  },
  {
    name: 'cameras.channels.channel_dms',
    displayName: 'Cameras Channels Channel Dms',
  },
  {
    name: 'cameras.channels.channel_ext1',
    displayName: 'Cameras Channels Channel Ext1',
  },
  {
    name: 'cameras.channels.channel_ext2',
    displayName: 'Cameras Channels Channel Ext2',
  },
  {
    name: 'cameras.channels.channel_ext3',
    displayName: 'Cameras Channels Channel Ext3',
  },
  {
    name: 'cameras.channels.channel_ext4',
    displayName: 'Cameras Channels Channel Ext4',
  },
  {
    name: 'cameras.channels.channel_outward',
    displayName: 'Cameras Channels Channel Outward',
  },
  {
    name: 'cameras.wake_device',
    displayName: 'Cameras Wake Device',
  },
  {
    name: 'client_delete_user',
    displayName: 'Client Delete User',
  },
  {
    name: 'client_edit',
    displayName: 'Client Edit',
  },
  {
    name: 'client_edit_user',
    displayName: 'Client Edit User',
  },
  {
    name: 'client_new_user',
    displayName: 'Client New User',
  },
  {
    name: 'client_notes_history',
    displayName: 'Client Notes History',
  },
  {
    name: 'client_users_list',
    displayName: 'Client Users List',
  },
  {
    name: 'client_view',
    displayName: 'Client View',
  },
  {
    name: 'configuration.areas',
    displayName: 'Configuration Areas',
  },
  {
    name: 'configuration.areas.areas_groups_list.add',
    displayName: 'Configuration Areas Areas Groups List Add',
  },
  {
    name: 'configuration.areas.areas_groups_list.archive',
    displayName: 'Configuration Areas Areas Groups List Archive',
  },
  {
    name: 'configuration.areas.areas_groups_list.delete',
    displayName: 'Configuration Areas Areas Groups List Delete',
  },
  {
    name: 'configuration.areas.areas_groups_list.edit',
    displayName: 'Configuration Areas Areas Groups List Edit',
  },
  {
    name: 'configuration.areas.areas_list.add',
    displayName: 'Configuration Areas Areas List Add',
  },
  {
    name: 'configuration.areas.areas_list.archive',
    displayName: 'Configuration Areas Areas List Archive',
  },
  {
    name: 'configuration.areas.areas_list.delete',
    displayName: 'Configuration Areas Areas List Delete',
  },
  {
    name: 'configuration.areas.areas_list.edit',
    displayName: 'Configuration Areas Areas List Edit',
  },
  {
    name: 'configuration.driving_options.edit',
    displayName: 'Configuration Driving Options Edit',
  },
  {
    name: 'configuration.fleet',
    displayName: 'Configuration Fleet',
  },
  {
    name: 'configuration.fleet.depot_list.add',
    displayName: 'Configuration Fleet Depot List Add',
  },
  {
    name: 'configuration.fleet.depot_list.delete',
    displayName: 'Configuration Fleet Depot List Delete',
  },
  {
    name: 'configuration.fleet.depot_list.edit',
    displayName: 'Configuration Fleet Depot List Edit',
  },
  {
    name: 'configuration.fleet.vehicle_groups_list.add',
    displayName: 'Configuration Fleet Vehicle Groups List Add',
  },
  {
    name: 'configuration.fleet.vehicle_groups_list.delete',
    displayName: 'Configuration Fleet Vehicle Groups List Delete',
  },
  {
    name: 'configuration.fleet.vehicle_groups_list.edit',
    displayName: 'Configuration Fleet Vehicle Groups List Edit',
  },
  {
    name: 'configuration.integrations_list',
    displayName: 'Configuration Integrations List',
  },
  {
    name: 'configuration.integrations_list.edit',
    displayName: 'Configuration Integrations List Edit',
  },
  {
    name: 'configuration.templates',
    displayName: 'Configuration Templates',
  },
  {
    name: 'configuration.templates.edit',
    displayName: 'Configuration Templates Edit',
  },
  {
    name: 'configuration.user_group_list',
    displayName: 'Configuration User Group List',
  },
  {
    name: 'configuration.user_group_list.add',
    displayName: 'Configuration User Group List Add',
  },
  {
    name: 'configuration.user_group_list.archive',
    displayName: 'Configuration User Group List Archive',
  },
  {
    name: 'configuration.user_group_list.areas',
    displayName: 'Configuration User Group List Areas',
  },
  {
    name: 'configuration.user_group_list.delete',
    displayName: 'Configuration User Group List Delete',
  },
  {
    name: 'configuration.user_group_list.edit',
    displayName: 'Configuration User Group List Edit',
  },
  {
    name: 'configuration.user_group_list.modules',
    displayName: 'Configuration User Group List Modules',
  },
  {
    name: 'configuration.user_group_list.vehicles',
    displayName: 'Configuration User Group List Vehicles',
  },
  {
    name: 'configuration_company_info',
    displayName: 'Configuration Company Info',
  },
  {
    name: 'configuration_driving_options',
    displayName: 'Configuration Driving Options',
  },
  {
    name: 'configuration_fleet',
    displayName: 'Configuration Fleet',
  },
  {
    name: 'configuration_geofences',
    displayName: 'Configuration Geofences',
  },
  {
    name: 'configuration_notifications',
    displayName: 'Configuration Notifications',
  },
  {
    name: 'configuration_section',
    displayName: 'Configuration Section',
  },
  {
    name: 'configuration_templates',
    displayName: 'Configuration Templates',
  },
  {
    name: 'configuration_user_groups',
    displayName: 'Configuration User Groups',
  },
  {
    name: 'configuration_users',
    displayName: 'Configuration Users',
  },
  {
    name: 'depot_delete',
    displayName: 'Depot Delete',
  },
  {
    name: 'depot_edit',
    displayName: 'Depot Edit',
  },
  {
    name: 'depot_new',
    displayName: 'Depot New',
  },
  {
    name: 'device.devices_list.archive',
    displayName: 'Device Devices List Archive',
  },
  {
    name: 'device.devices_list.raw_data_log',
    displayName: 'Device Devices List Raw Data Log',
  },
  {
    name: 'device.devices_list.unavailable',
    displayName: 'Device Devices List Unavailable',
  },
  {
    name: 'device_edit',
    displayName: 'Device Edit',
  },
  {
    name: 'device_install_uninstall',
    displayName: 'Device Install Uninstall',
  },
  {
    name: 'device_list',
    displayName: 'Device List',
  },
  {
    name: 'device_notes_history',
    displayName: 'Device Notes History',
  },
  {
    name: 'device_sensor_create',
    displayName: 'Device Sensor Create',
  },
  {
    name: 'device_sensor_delete',
    displayName: 'Device Sensor Delete',
  },
  {
    name: 'device_sensor_edit',
    displayName: 'Device Sensor Edit',
  },
  {
    name: 'device_sensor_io_types_list',
    displayName: 'Device Sensor Io Types List',
  },
  {
    name: 'device_sensor_list',
    displayName: 'Device Sensor List',
  },
  {
    name: 'device_sensor_view',
    displayName: 'Device Sensor View',
  },
  {
    name: 'devices_edit_device',
    displayName: 'Devices Edit Device',
  },
  {
    name: 'devices_edit_raw_data_log',
    displayName: 'Devices Edit Raw Data Log',
  },
  {
    name: 'devices_edit_status',
    displayName: 'Devices Edit Status',
  },
  {
    name: 'devices_edit_vehicle',
    displayName: 'Devices Edit Vehicle',
  },
  {
    name: 'devices_section',
    displayName: 'Devices Section',
  },
  {
    name: 'document_delete',
    displayName: 'Document Delete',
  },
  {
    name: 'document_edit',
    displayName: 'Document Edit',
  },
  {
    name: 'document_list',
    displayName: 'Document List',
  },
  {
    name: 'document_new',
    displayName: 'Document New',
  },
  {
    name: 'driver_list',
    displayName: 'Driver List',
  },
  {
    name: 'drivers',
    displayName: 'Drivers',
  },
  {
    name: 'drivers.documents_list',
    displayName: 'Drivers Documents List',
  },
  {
    name: 'drivers.documents_list.add',
    displayName: 'Drivers Documents List Add',
  },
  {
    name: 'drivers.documents_list.archive',
    displayName: 'Drivers Documents List Archive',
  },
  {
    name: 'drivers.documents_list.delete',
    displayName: 'Drivers Documents List Delete',
  },
  {
    name: 'drivers.documents_list.edit',
    displayName: 'Drivers Documents List Edit',
  },
  {
    name: 'drivers.documents_list.records_list',
    displayName: 'Drivers Documents List Records List',
  },
  {
    name: 'drivers.documents_list.records_list.add',
    displayName: 'Drivers Documents List Records List Add',
  },
  {
    name: 'drivers.drivers_list.add',
    displayName: 'Drivers Drivers List Add',
  },
  {
    name: 'drivers.drivers_list.archive',
    displayName: 'Drivers Drivers List Archive',
  },
  {
    name: 'drivers.drivers_list.block_user',
    displayName: 'Drivers Drivers List Block User',
  },
  {
    name: 'drivers.drivers_list.delete',
    displayName: 'Drivers Drivers List Delete',
  },
  {
    name: 'drivers.drivers_list.edit',
    displayName: 'Drivers Drivers List Edit',
  },
  {
    name: 'drivers.drivers_list.reset_password',
    displayName: 'Drivers Drivers List Reset Password',
  },
  {
    name: 'drivers_add_driver',
    displayName: 'Drivers Add Driver',
  },
  {
    name: 'drivers_edit_access_info',
    displayName: 'Drivers Edit Access Info',
  },
  {
    name: 'drivers_edit_profile_info',
    displayName: 'Drivers Edit Profile Info',
  },
  {
    name: 'drivers_section',
    displayName: 'Drivers Section',
  },
  {
    name: 'driving_behaviour',
    displayName: 'Driving Behaviour',
  },
  {
    name: 'driving_behaviour.dashboard',
    displayName: 'Driving Behaviour Dashboard',
  },
  {
    name: 'driving_behaviour.drivers',
    displayName: 'Driving Behaviour Drivers',
  },
  {
    name: 'driving_behaviour.vehicles',
    displayName: 'Driving Behaviour Vehicles',
  },
  {
    name: 'driving_behaviour_dashboard',
    displayName: 'Driving Behaviour Dashboard',
  },
  {
    name: 'driving_behaviour_drivers',
    displayName: 'Driving Behaviour Drivers',
  },
  {
    name: 'driving_behaviour_section',
    displayName: 'Driving Behaviour Section',
  },
  {
    name: 'driving_behaviour_vehicles',
    displayName: 'Driving Behaviour Vehicles',
  },
  {
    name: 'fleet',
    displayName: 'Fleet',
  },
  {
    name: 'fleet.dashboard',
    displayName: 'Fleet Dashboard',
  },
  {
    name: 'fleet.documents_list.add',
    displayName: 'Fleet Documents List Add',
  },
  {
    name: 'fleet.documents_list.archive',
    displayName: 'Fleet Documents List Archive',
  },
  {
    name: 'fleet.documents_list.delete',
    displayName: 'Fleet Documents List Delete',
  },
  {
    name: 'fleet.documents_list.edit',
    displayName: 'Fleet Documents List Edit',
  },
  {
    name: 'fleet.documents_list.records_list',
    displayName: 'Fleet Documents List Records List',
  },
  {
    name: 'fleet.documents_list.records_list.add',
    displayName: 'Fleet Documents List Records List Add',
  },
  {
    name: 'fleet.inspection_forms_list',
    displayName: 'Fleet Inspection Forms List',
  },
  {
    name: 'fleet.inspection_forms_list.add',
    displayName: 'Fleet Inspection Forms List Add',
  },
  {
    name: 'fleet.inspection_forms_list.delete',
    displayName: 'Fleet Inspection Forms List Delete',
  },
  {
    name: 'fleet.inspection_forms_list.edit',
    displayName: 'Fleet Inspection Forms List Edit',
  },
  {
    name: 'fleet.repair_costs_list.add',
    displayName: 'Fleet Repair Costs List Add',
  },
  {
    name: 'fleet.repair_costs_list.delete',
    displayName: 'Fleet Repair Costs List Delete',
  },
  {
    name: 'fleet.repair_costs_list.edit',
    displayName: 'Fleet Repair Costs List Edit',
  },
  {
    name: 'fleet.service_reminders_list.add',
    displayName: 'Fleet Service Reminders List Add',
  },
  {
    name: 'fleet.service_reminders_list.archive',
    displayName: 'Fleet Service Reminders List Archive',
  },
  {
    name: 'fleet.service_reminders_list.delete',
    displayName: 'Fleet Service Reminders List Delete',
  },
  {
    name: 'fleet.service_reminders_list.edit',
    displayName: 'Fleet Service Reminders List Edit',
  },
  {
    name: 'fleet.service_reminders_list.service_record_list.add',
    displayName: 'Fleet Service Reminders List Service Record List Add',
  },
  {
    name: 'fleet.service_reminders_list.service_record_list.delete',
    displayName: 'Fleet Service Reminders List Service Record List Delete',
  },
  {
    name: 'fleet.service_reminders_list.service_record_list.edit',
    displayName: 'Fleet Service Reminders List Service Record List Edit',
  },
  {
    name: 'fleet_section',
    displayName: 'Fleet Section',
  },
  {
    name: 'fleet_section_add_vehicle',
    displayName: 'Fleet Section Add Vehicle',
  },
  {
    name: 'fleet_section_check_vehicle',
    displayName: 'Fleet Section Check Vehicle',
  },
  {
    name: 'fleet_section_dashboard',
    displayName: 'Fleet Section Dashboard',
  },
  {
    name: 'fleet_section_edit_documents',
    displayName: 'Fleet Section Edit Documents',
  },
  {
    name: 'fleet_section_edit_general',
    displayName: 'Fleet Section Edit General',
  },
  {
    name: 'fleet_section_edit_repair_costs',
    displayName: 'Fleet Section Edit Repair Costs',
  },
  {
    name: 'fleet_section_edit_service_reminder',
    displayName: 'Fleet Section Edit Service Reminder',
  },
  {
    name: 'fleet_section_edit_specification',
    displayName: 'Fleet Section Edit Specification',
  },
  {
    name: 'fleet_section_edit_status',
    displayName: 'Fleet Section Edit Status',
  },
  {
    name: 'fleet_section_fleet',
    displayName: 'Fleet Section Fleet',
  },
  {
    name: 'fuel',
    displayName: 'Fuel',
  },
  {
    name: 'fuel.fuel_record_update',
    displayName: 'Fuel Fuel Record Update',
  },
  {
    name: 'fuel.import_data',
    displayName: 'Fuel Import Data',
  },
  {
    name: 'fuel.records',
    displayName: 'Fuel Records',
  },
  {
    name: 'fuel.summary',
    displayName: 'Fuel Summary',
  },
  {
    name: 'fuel_import_data',
    displayName: 'Fuel Import Data',
  },
  {
    name: 'fuel_records',
    displayName: 'Fuel Records',
  },
  {
    name: 'fuel_section',
    displayName: 'Fuel Section',
  },
  {
    name: 'fuel_summary',
    displayName: 'Fuel Summary',
  },
  {
    name: 'map',
    displayName: 'Map',
  },
  {
    name: 'map.areas',
    displayName: 'Map Areas',
  },
  {
    name: 'map.assets',
    displayName: 'Map Assets',
  },
  {
    name: 'map.drivers',
    displayName: 'Map Drivers',
  },
  {
    name: 'map.vehicle',
    displayName: 'Map Vehicle',
  },
  {
    name: 'map.vehicle.share_tracking_link',
    displayName: 'Map Vehicle Share Tracking Link',
  },
  {
    name: 'map_section',
    displayName: 'Map Section',
  },
  {
    name: 'map_section_drivers',
    displayName: 'Map Section Drivers',
  },
  {
    name: 'map_section_geofences',
    displayName: 'Map Section Geofences',
  },
  {
    name: 'map_section_vehicle',
    displayName: 'Map Section Vehicle',
  },
  {
    name: 'messenger',
    displayName: 'Messenger',
  },
  {
    name: 'messenger.create_chat',
    displayName: 'Messenger Create Chat',
  },
  {
    name: 'messenger.show_all',
    displayName: 'Messenger Show All',
  },
  {
    name: 'reminder_delete',
    displayName: 'Reminder Delete',
  },
  {
    name: 'reminder_edit',
    displayName: 'Reminder Edit',
  },
  {
    name: 'reminder_list',
    displayName: 'Reminder List',
  },
  {
    name: 'reminder_new',
    displayName: 'Reminder New',
  },
  {
    name: 'repair_cost_delete',
    displayName: 'Repair Cost Delete',
  },
  {
    name: 'repair_cost_edit',
    displayName: 'Repair Cost Edit',
  },
  {
    name: 'repair_cost_new',
    displayName: 'Repair Cost New',
  },
  {
    name: 'reports',
    displayName: 'Reports',
  },
  {
    name: 'reports_driver_behaviour',
    displayName: 'Reports Driver Behaviour',
  },
  {
    name: 'reports_fuel',
    displayName: 'Reports Fuel',
  },
  {
    name: 'reports_geofences',
    displayName: 'Reports Geofences',
  },
  {
    name: 'reports_maintenance',
    displayName: 'Reports Maintenance',
  },
  {
    name: 'reports_routes',
    displayName: 'Reports Routes',
  },
  {
    name: 'reports_section',
    displayName: 'Reports Section',
  },
  {
    name: 'reports_sensors',
    displayName: 'Reports Sensors',
  },
  {
    name: 'reports_sensors_io',
    displayName: 'Reports Sensors Io',
  },
  {
    name: 'reports_summary',
    displayName: 'Reports Summary',
  },
  {
    name: 'reseller_team_section',
    displayName: 'Reseller Team Section',
  },
  {
    name: 'scheduled_report_create',
    displayName: 'Scheduled Report Create',
  },
  {
    name: 'scheduled_report_delete',
    displayName: 'Scheduled Report Delete',
  },
  {
    name: 'scheduled_report_edit',
    displayName: 'Scheduled Report Edit',
  },
  {
    name: 'scheduled_report_list',
    displayName: 'Scheduled Report List',
  },
  {
    name: 'scheduled_report_view',
    displayName: 'Scheduled Report View',
  },
  {
    name: 'service_record_delete',
    displayName: 'Service Record Delete',
  },
  {
    name: 'service_record_edit',
    displayName: 'Service Record Edit',
  },
  {
    name: 'service_record_list',
    displayName: 'Service Record List',
  },
  {
    name: 'service_record_new',
    displayName: 'Service Record New',
  },
  {
    name: 'support.knowledge_base',
    displayName: 'Support Knowledge Base',
  },
  {
    name: 'support_section',
    displayName: 'Support Section',
  },
  {
    name: 'user_group_delete',
    displayName: 'User Group Delete',
  },
  {
    name: 'user_group_edit',
    displayName: 'User Group Edit',
  },
  {
    name: 'user_group_list',
    displayName: 'User Group List',
  },
  {
    name: 'user_group_new',
    displayName: 'User Group New',
  },
  {
    name: 'vehicle_delete',
    displayName: 'Vehicle Delete',
  },
  {
    name: 'vehicle_edit',
    displayName: 'Vehicle Edit',
  },
  {
    name: 'vehicle_group_delete',
    displayName: 'Vehicle Group Delete',
  },
  {
    name: 'vehicle_group_edit',
    displayName: 'Vehicle Group Edit',
  },
  {
    name: 'vehicle_group_new',
    displayName: 'Vehicle Group New',
  },
  {
    name: 'vehicle_inspection_plan_create',
    displayName: 'Vehicle Inspection Plan Create',
  },
  {
    name: 'vehicle_inspection_plan_edit',
    displayName: 'Vehicle Inspection Plan Edit',
  },
  {
    name: 'vehicle_inspection_plan_list',
    displayName: 'Vehicle Inspection Plan List',
  },
  {
    name: 'vehicle_list',
    displayName: 'Vehicle List',
  },
  {
    name: 'vehicle_notes_history',
    displayName: 'Vehicle Notes History',
  },
]

export const FALLBACK_NOTIFICATION_POPUP_SETTING = { name: 'notificationPopup', value: true }

export const FALLBACK_NOTIFICATION_SOUND_SETTING = { name: 'notificationSound', value: true }

export const FALLBACK_NOTIFICATION_COUNT = 0

// TODO(BE-A-005): remove when Go /me returns timezone as `{id, displayName, name}` instead of null.
// Spec: local-docs/api-specs-tri-env/auth-tri-env-spec-2026-05-13.md (item A-005).
// Value sourced from danny.le@linxio.com on PHP prod.
export const FALLBACK_USER_TIMEZONE = {
  id: 1109,
  displayName: '(UTC+08:00) Asia/Manila',
  name: 'Asia/Manila',
}

export const FALLBACK_COUNTRY_LIST: Record<string, string> = {
  AF: 'Afghanistan',
  AX: 'Aland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua And Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BA: 'Bosnia And Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, Democratic Republic',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Cote D'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island & Mcdonald Islands',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic Of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle Of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KR: 'Korea',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyan Arab Jamahiriya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States Of',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  AN: 'Netherlands Antilles',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinian Territory, Occupied',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthelemy',
  SH: 'Saint Helena',
  KN: 'Saint Kitts And Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin',
  PM: 'Saint Pierre And Miquelon',
  VC: 'Saint Vincent And Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome And Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia And Sandwich Isl.',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard And Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad And Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks And Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UM: 'United States Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Viet Nam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  WF: 'Wallis And Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
}

export const FALLBACK_THEMES_LIST = [
  {
    id: 5,
    name: 'Light Theme',
    accentColor: '#512da8',
    primaryBackgroundColor: '#ffffff',
    secondaryBackgroundColor: '#f4f8f9',
    menuBackgroundColor: '#110A21',
    primaryBorderColor: '#ced4db',
    primaryFontColor: 'black',
    secondaryFontColor: '#7a7a7a',
    logoSrc: '/assets/images/logo-light.svg',
  },
  {
    id: 6,
    name: 'Dark Theme',
    accentColor: '#8557d8',
    primaryBackgroundColor: '#2e2f30',
    secondaryBackgroundColor: '#212324',
    menuBackgroundColor: '#110A21',
    primaryBorderColor: 'rgba(255,255,255, 0.20)',
    primaryFontColor: 'white',
    secondaryFontColor: '#7a7a7a',
    logoSrc: '/assets/images/logo-dark.svg',
  },
  {
    id: 7,
    name: 'NEPT Light theme',
    accentColor: '#512da8',
    primaryBackgroundColor: '#ffffff',
    secondaryBackgroundColor: '#f4f8f9',
    menuBackgroundColor: '#110A21',
    primaryBorderColor: '#ced4db',
    primaryFontColor: 'black',
    secondaryFontColor: '#7a7a7a',
    logoSrc: '/assets/images/NSW-Healthshare.png',
  },
  {
    id: 8,
    name: 'Nokia Light theme',
    accentColor: '#512da8',
    primaryBackgroundColor: '#ffffff',
    secondaryBackgroundColor: '#f4f8f9',
    menuBackgroundColor: '#110A21',
    primaryBorderColor: '#ced4db',
    primaryFontColor: 'black',
    secondaryFontColor: '#7a7a7a',
    logoSrc: '/assets/images/nokia-logo-png-transparent.png',
  },
]

// TODO(xero-fake): delete FALLBACK_XERO_* block once BE implements /xero/* endpoints
// (POST/GET /xero/secret, GET /xero/accounts, GET /xero/contacts, GET /xero/client/:id/contact,
// POST /xero/client/contact). Xero cannot be hit on prod and PHP staging is broken — fake-only.
export const FALLBACK_XERO_CREDENTIALS = {
  xeroClientId: 'FAKE-CLIENT-ID-LINXIO-DEV',
  xeroClientSecret: 'FAKE-CLIENT-SECRET-LINXIO-DEV',
  teamId: 1,
  xeroAccountLineitemId: '297c2dc5-cc47-4afd-8ec8-74990b8761e9',
  xeroAccountPaymentId: 'a3d09ee7-1c52-4a14-9ec0-93b5a6e2c5f0',
}

export const FALLBACK_XERO_ACCOUNTS = [
  { class: 'REVENUE', code: '200', description: 'Sales', name: 'Sales' },
  { class: 'REVENUE', code: '260', description: 'Other Revenue', name: 'Other Revenue' },
  { class: 'REVENUE', code: '270', description: 'Interest Income', name: 'Interest Income' },
  { class: 'ASSET', code: '090', description: 'Business Bank Account', name: 'Business Bank Account' },
  { class: 'ASSET', code: '610', description: 'Accounts Receivable', name: 'Accounts Receivable' },
  { class: 'ASSET', code: '620', description: 'Prepayments', name: 'Prepayments' },
  { class: 'LIABILITY', code: '800', description: 'Accounts Payable', name: 'Accounts Payable' },
  { class: 'LIABILITY', code: '820', description: 'GST', name: 'GST' },
  { class: 'LIABILITY', code: '825', description: 'PAYG Withholdings Payable', name: 'PAYG Withholdings Payable' },
  { class: 'EXPENSE', code: '400', description: 'Advertising', name: 'Advertising' },
  { class: 'EXPENSE', code: '404', description: 'Bank Fees', name: 'Bank Fees' },
  { class: 'EXPENSE', code: '408', description: 'Cleaning', name: 'Cleaning' },
  { class: 'EXPENSE', code: '420', description: 'Entertainment', name: 'Entertainment' },
  { class: 'EXPENSE', code: '433', description: 'Insurance', name: 'Insurance' },
  { class: 'EQUITY', code: '960', description: 'Retained Earnings', name: 'Retained Earnings' },
]

export const FALLBACK_XERO_CONTACTS = [
  {
    contactId: '8c5e76f5-d3d3-4f80-9a25-3c1f72b1a01a',
    name: 'Acme Logistics Pty Ltd',
    client: { id: 101, name: 'Acme Logistics' },
  },
  {
    contactId: 'f1c4d9e8-1a2b-4c3d-9e8f-5a6b7c8d9e0f',
    name: 'BlueWave Transport Co.',
    client: { id: 102, name: 'BlueWave Transport' },
  },
  {
    contactId: 'd2a8c6b4-7e9f-4a1b-8c3d-2e4f6a8b0c2d',
    name: 'Sunrise Freight Ltd',
    client: null,
  },
  {
    contactId: '4b9a7c5e-3f1d-4a6b-9c8d-1e2f3a4b5c6d',
    name: 'Pinnacle Mining Services',
    client: null,
  },
  {
    contactId: '6e5d4c3b-2a1f-4e9d-8c7b-6a5f4e3d2c1b',
    name: 'Highland Constructions',
    client: { id: 103, name: 'Highland Group' },
  },
  {
    contactId: '9a8b7c6d-5e4f-3a2b-1c9d-8e7f6a5b4c3d',
    name: 'Outback Resources',
    client: null,
  },
  {
    contactId: '0c1d2e3f-4a5b-6c7d-8e9f-0a1b2c3d4e5f',
    name: 'Coastal Marine Services',
    client: { id: 104, name: 'Coastal Marine' },
  },
  {
    contactId: '1f2e3d4c-5b6a-7980-1a2b-3c4d5e6f7a8b',
    name: 'Northern Star Distribution',
    client: null,
  },
]

export const FALLBACK_XERO_CLIENT_CONTACT = {
  id: 1,
  client: { id: 101, name: 'Acme Logistics' },
  team: { id: 1, name: 'Linxio' },
  xeroContactId: '8c5e76f5-d3d3-4f80-9a25-3c1f72b1a01a',
}
